import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReactTable from "react-table";
import "react-table/react-table.css";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import { LoginService } from "../../services/login.service";
import { ProductService } from "../../services/product.service";
import $, { data } from "jquery";
import { unblockUser } from "../../services/admin.service";
// import { success, successNotification } from "../notification/notifications";
import { ExcelService } from "../Excel/excel";
import { success, successNotification, error, errorNotification, warning, warningNotification } from "../notification/notifications";
import { GeneralEnquiryService } from "../../services/generalenquiryService";
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
//import { fetchDistributor } from "../../services/distributor.service";
import { fetchBatchDistributor } from "../../services/distributor.service";
// import DashboardHeader from "../dashboardheader/dashboardheader";
import { RegionManagementService } from "../../services/regionManagement.service";
import {LookUpService}from "../../services/lookupService"
import jsPDF from "jspdf";
import "jspdf-autotable";
import Select,{ createFilter } from 'react-select';
import Funnel from "../distributorList/funnel"
import { ReattemptTestService } from "../../services/reattemptTest.service";
import { RegisterUserService } from "../../services/registration.service";
//import { updateStatus,sendAmcList, auditTrail } from "../../services/preAssessment.Service"
import { updateStatus,sendAmcList } from "../../services/preAssessment.Service"
import * as moment from "moment";
import { AssessmentReport } from "../../services/fetchAssessmentReport";
import ciellogo from '../../assets/images/ciel-logo.png';
import CielSignature from '../../assets/images/ciel-sign.png';
import Modal from "react-responsive-modal";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { Global_var } from "../../global/global_var";

class DistributorList extends Component {
  constructor(props) {
    super(props);
    if (localStorage.getItem('login') !== null) {
      this.state = {
        roleType: "",
        cheeseIsReady: 1,
        ca_address_id: "",
        ca_address_1: "",
        ca_address_2: "",
        ca_country: "",
        ca_state: "",
        ca_city: "",
        ca_postal_code: "",
        pa_address_id: "",
        pa_address_1: "",
        pa_address_2: "",
        pa_country: "",
        pa_state: "",
        pa_city: "",
        pa_postal_code: "",
        learnerFatherName: "",
        learnerFatherDOB: "",
        learnerFatherEmployementType: "",
        learnerFatherCompanyName: "",
        learnerMotherName: "",
        learnerMotherDOB: "",
        learnerMotherEmployementType: "",
        learnerMotherCompanyName: "",
        addressFlag: false,
        adminUserFlag: false,
        respnoseData: this.props.distributorProfileUser,
        selectionuser: [],
        selectAlluser: false,
        disableapproveuser: true,
        disabledownloaduser: true,
        filtered: [],
        cityList: [],
        allCityList:[],
        lookingForList:[],
        AuualIncomeList:[],
        auditData:[],
        // griddata: (this.props || '').adminUser ? this.props.adminUser.filter(
        //   role => role.userRoleMatrixList[0].roleId.roleId !== 1
        // ) : [],
        loading: false,
        selectedOption: null,
        stateListForPer:[],
        occupation:[],
        Stage:[],
        img:'',
        nextStageValue:'',
        
        selected: {},
        selectAll: 0,
        data: [ 
        ],
        productData: [],
        mailData:[],
        smsData:[],
        smsDataProfile:[],
        isAllow:true,
        isData:false,
        Scoredata:[],
        exportData:[],
        fromDate:new Date(),
        mailDataAmc:[],
        mailDataKYD:[],
        smsEmpanelmentData:[],
        AmcList:[],
        nextStage: [
      
            {
              "currentState": "REGISTERED",
              "nextState": "PROFILE COMPLETED"
      
            },
            {
              "currentState": "PROFILE COMPLETED",
              "nextState": "FEAT COMPLETED"
      
            },
            {
              "currentState": "FEAT COMPLETED",
              "nextState": "NISM VA SUBSCRIBED"
      
            },
            {
              "currentState": "NISM VA SUBSCRIBED",
              "nextState": "NISM VA PAYMENT COMPLETED"
      
            },
            
            {
              "currentState": "NISM VA PAYMENT COMPLETED",
              "nextState": "NISM PROFILE CREATED"
      
            },
            {
              "currentState": "NISM PROFILE CREATED",
              "nextState": "NISM EXAM DATE CONFIRMED"
      
            },
            {
              "currentState": "NISM EXAM DATE CONFIRMED",
              "nextState": "ADMIT CARD AVAILABLE"
      
            },
            {
              "currentState": "ADMIT CARD AVAILABLE",
              "nextState": "NISM VA CERTIFICATION"
      
            },
            {
              "currentState": "NISM VA CERTIFICATION",
              "nextState": "KYD-ARN APPLIED"
      
            },
            {
              "currentState": "KYD-ARN APPLIED",
              "nextState": "KYD-ARN STATUS"
      
            },
            {
              "currentState": "KYD-ARN STATUS",
              "nextState": "UNDER EMPANELMENT"
      
            },
            {
              "currentState": "UNDER EMPANELMENT",
              "nextState": "EMPANELED"
      
            }
          ],
          listOfMonth:[],
          listOfYear1:[],
          listOfDay:[],
          mailDataKYD:[]
        
      }

    }
    else {
      window.location.href = '/';
    }
  }

  
  componentDidMount() {
    var year = new Date().getFullYear();
    year = year
    var listOfYear = [];
    for (var i = 0; i < 100; i++) {
      var current = year - i;
      listOfYear.push(current);

    }
    var listOfMonth = [];
    // for (var i = 1; i <= 12; i++) {
    //   // var current = year - i;
    //   listOfMonth.push(i);

    // }

    var listOfMonth = [{ "key": 1, "value": "Jan" },
    { "key": 2, "value": "Feb" },
    { "key": 3, "value": "Mar" },
    { "key": 4, "value": "Apr" },
    { "key": 5, "value": "May" },
    { "key": 6, "value": "Jun" },
    { "key": 7, "value": "Jul" },
    { "key": 8, "value": "Aug" },
    { "key": 9, "value": "Sep" },
    { "key": 10, "value": "Oct" },
    { "key": 11, "value": "Nov" },
    { "key": 12, "value": "Dec" },
    ];

    var listOfDay = [];
    for (var i = 1; i <= 31; i++) {
      //    var current = year - i;
      listOfDay.push(i);

    }
    this.setState({ listOfMonth: listOfMonth });
    this.setState({ listOfYear1: listOfYear });
    this.setState({ listOfDay: listOfDay });


localStorage.setItem("stage","")
      LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
     localStorage.setItem("jti-token", res.responseObject);
      RegionManagementService.getCity("",res => {
          let city=[]
          for(let i=0;i<res.responseListObject?.length;i++)
          {
            let obj={}
            obj['value']=res.responseListObject[i].cityId
            obj['label']=res.responseListObject[i].cityName
            city.push(obj)
          }        
          this.setState({
            cityList:city,
            allCityList:res.responseListObject
          });
      
        }
      );
      RegionManagementService.getState("countryId=1",
        res => {
          this.setState({
            stateListForPer: res.responseListObject
          });
        }
      );
    });

    LookUpService.getLookingFor("codeTypeId=100",res => {
        this.setState({lookingForList: res.responseListObject});
      }
    );
    
    LookUpService.getOccuption("codeTypeId=102",res => {
        this.setState({occupation: res.responseListObject});
      }
    );

    LookUpService.getWhoareu("codeTypeId=105&sortOrder=ASC",
      res => {
      this.setState({
          AuualIncomeList: res.responseListObject,
        });
      }
    );

    LookUpService.getAmc(
      res => {
      this.setState({
          AmcList: res.responseListObject,
        });
      }
    );
  }
  batchReport=()=>{
   this.setState({loading:true})
    AssessmentReport.fetchBatchReport(
      "firstName=&lastName=&fromDate=&toDate=&emailId=&panNumber=&cityId=0&roleId=" +
       localStorage.getItem("roleId") + "&applicationStatus=&stage=&additionalDetail=false&examLocation=&examFromDate=&examToDate=&stateId=&learnerId=0&amcId=0",
       res=> {
       if(res.status==="success"){

         success("Batch Report Send !!!", successNotification);
         this.setState({loading:false})
       } 
      else{
        this.setState({loading:false})
      }
  
    })
  }
  filterCfxReport(emailId, productID) {
    LoginService.TokenUser(res => {

        localStorage.setItem("jwt-token", res.responseObject);
        //let params = "emailid=dapsachin@test.com" //this.props.match.params.id
        let params = "emailid=" + emailId;
        params += "&productid=" + productID // this.props.match.params.prodid //"&productid=1"; //

        let cfxDataArray = [];
        AssessmentReport.fetchCfxAssessmentReport(params, res => {
            console.log(res);
            if (res.reasonText !== "Record not found") {


                res.responseListObject.forEach(element => {
                    let cfxData = {
                        learnerReportId: element.learnerReportId,
                        learneremailid: element.emailid,
                        learnerlearningid: element.learningid,
                        learnerlearningName: element.learningName,
                        learnerlearningProgress: element.learningProgress,
                        //  learnerlearningCompletionDate: element.learningCompletionDate != null ? moment(element.learningCompletionDate).format("DD-MM-YYYY") : "",
                        learnerlearningStatus: element.learningStatus,
                        learnerlearningType: element.learningType,
                        learnerproductid: element.productid,
                        learnernode: JSON.parse(element.node),
                    }
                    cfxDataArray.push(cfxData);
                });
                this.setState({ Scoredata: cfxDataArray });
                window.$('#progressBarPopup').modal('show')
            } else {
             // window.$('#progressBarPopup').modal('show')
                warning(res.reasonText, warningNotification);
            }
        }, error => {
            console.log(error);
        })

    });

}
  paymentLinkOption = (props) => {
    
    this.props.history.push("/my-inbox-compose", {
      alerts: this.props.alertNotificationEvents,
      notification: this.props.notificationEvents,
      userRoleAccess : this.props.userRoleAccess,
      learnerDetails : props
    }
    )
  } 

  WhyTheFillForm = () => {
    this.setState({ linkModalloading: true, showWhyTheFillForm: true });
  }

  onWhyTheFillFormCloseModal = () => {
    this.setState({ linkModalloading: false, showWhyTheFillForm: false });
  };
  exportPDFUserProfile = () => {
 
 
    console.log(this.state.exportData)
  let data1=  this.state.exportData?.length>0? this.state.exportData:[]
  if(data1?.length>0)
  {
  //data1.map(respData=>{

  for(let i1=0; i1<data1?.length;i1++)
  {
   // alert(i1)
   const respData = data1[i1]
    const check = this.state.cityList
    console.log(JSON.stringify(respData))
    var personalDetail = {}
    var tempaddressDetails = {}
    var permanentaddressDetails = {}
    var bankDetails = {}
    var qualificationDetails ={}
    //Personal Detail
    const firstName = respData.firstName ? respData.firstName : ""
    const middleName = respData.middleName ? respData.middleName : ""
    const lastName = respData.lastName ? respData.lastName : ""

    let title1=firstName+"-"+lastName+".pdf"
    personalDetail["name"] = "Name : "+firstName + " "+middleName + " "+lastName
   // personalDetail["blank_1"] = " "
    const dob = respData.dob? respData.dob.split(' ') :"  "
    personalDetail["dob"] = "Date of Birth : "+dob[0]
    const gender = respData.gender ===0 ? "Male" : "Female"
    personalDetail["gender"] = "Gender : "+gender
    var data = respData.mobileNo ? respData.mobileNo : ""
    personalDetail["mobileNo_1"] = "Mobile Number 1 : "+data
    data = respData.contactNo ? respData.contactNo : ""
    personalDetail["mobileNo_2"] = "Mobile Number 2 : "+data
    data = respData.panNumber ? respData.panNumber : ""
    personalDetail["panNo"] = "PAN Number : "+data
    // data = respData.aadharNumber ? respData.aadharNumber : ""
    // personalDetail["aadharNo"] = "Aadhaar Number : "+data
    data = respData.emailID ? respData.emailID : ""
    personalDetail["emaiId_2"] = "Email Id 1 : "+data
    data = respData.secondaryEmailID ? respData.secondaryEmailID : ""
    personalDetail["emaiId_1"] = "Email Id 2 : "+data
    // Correspondence Address Details
    const street = respData.address[0].street ? respData.address[0].street : ""
    tempaddressDetails["line1"] = "Address Line 1 : "+ street
    // tempaddressDetails["blank_1"] = " "
    // tempaddressDetails["blank_2"] = " "
    // tempaddressDetails["blank_3"] = " "
   
    // tempaddressDetails["blank_4"] = " "
    // tempaddressDetails["blank_5"] = " "
    // tempaddressDetails["blank_6"] = " "
    const street2 = respData.address[0].street2 ? respData.address[0].street2 : ""
    tempaddressDetails["line2"] = "Address Line 2 : "+street2
    const street3 = respData.address[0].street3 ? respData.address[0].street3 : ""
    tempaddressDetails["line3"] = "Address Line 3 : "+street3




    
    // tempaddressDetails["blank_7"] = " "
    // tempaddressDetails["blank_8"] = " "
    // tempaddressDetails["blank_9"] = " "
    
    var country = respData.address[0].countryId ? respData.address[0].countryId : ""
    const countryName = country === 1 ? "India" : "India"
    tempaddressDetails["country"] = "Country : "+countryName
   

    
    var state = respData.address[0].stateId ? respData.address[0].stateId : ""
    const tempstateName = this.getState(state)
    const tempStateFinal = tempstateName.charAt(0).toUpperCase() + tempstateName.slice(1)
    tempaddressDetails["state"] = "State : "+tempStateFinal
    var city = respData.address[0].cityId ? respData.address[0].cityId : ""
    const tempcityName = this.getCity(city)
    const tempCityFinal = tempcityName.charAt(0).toUpperCase() + tempcityName.slice(1)
    tempaddressDetails["city"] = "City : "+tempCityFinal
    var postalCode = respData.address[0].postalCode ? respData.address[0].postalCode : ""
    tempaddressDetails["postalCode"] = "Postal Code : "+postalCode
    //Permanent Address Details
    data = respData.address[1].street ? respData.address[1].street : ""
    permanentaddressDetails["line1"] = "Address Line 1 : "+data
    // permanentaddressDetails["blank_1"] = " "
    // permanentaddressDetails["blank_2"] = " "
    // permanentaddressDetails["blank_3"] = " "
   
    // permanentaddressDetails["blank_4"] = " "
    // permanentaddressDetails["blank_5"] = " "
    // permanentaddressDetails["blank_6"] = " "
    data = respData.address[1].street2 ? respData.address[1].street2 : ""
    permanentaddressDetails["line2"] = "Address Line 2 : "+data

    
    data = respData.address[1].street3 ? respData.address[1].street3 : ""
    permanentaddressDetails["line3"] = "Address Line 3 : "+data
    // permanentaddressDetails["blank_7"] = " "
    // permanentaddressDetails["blank_8"] = " "
    // permanentaddressDetails["blank_9"] = " "
    data = respData.address[1].countryId ? respData.address[1].countryId : ""
    const CountryName = data === 1 ? "India" : "India"
    permanentaddressDetails["country"] = "Country : "+CountryName
    
    data = respData.address[1].stateId ? respData.address[1].stateId : ""
    state = respData.address[1].stateId ? respData.address[1].stateId : ""
    const stateName = this.getState(state)
    const stateFinal = stateName.charAt(0).toUpperCase() + stateName.slice(1)
    permanentaddressDetails["state"] = "State : "+stateFinal

    data = respData.address[1].cityId ? respData.address[1].cityId : ""
    city = respData.address[1].cityId ? respData.address[1].cityId : ""
    const cityName = this.getCity(city)
    const cityFinal = cityName.charAt(0).toUpperCase() + cityName.slice(1)
    permanentaddressDetails["city"] = "City : "+cityFinal
    data = respData.address[1].postalCode ? respData.address[1].postalCode : ""
    permanentaddressDetails["postalCode"] = "Postal Code : "+data
    
    // Bank Details
    data= respData.ifscCode ? respData.ifscCode : ""
    bankDetails["IFSCCode"] = "IFSC Code : "+data
    data= respData.bankName ? respData.bankName : ""
    bankDetails["bankName"] = "Name of The Bank : "+data
    data = respData.accountNumber ? respData.accountNumber : ""
    bankDetails["accountNumber"] = "Account Number : "+data
    data = respData.accountType ? respData.accountType : ""
    
    var AccType = data === 1 ? "Saving Account" : "Current Account"
    bankDetails["accountType"] = "Account Type : "+AccType
    data = respData.branchName ? respData.branchName : ""
    bankDetails["branch"] = "Branch : "+data
    data = respData.branchAddress ? respData.branchAddress : ""
    bankDetails["branchAddress"] = "Branch Address : "+data
    
    // Qualification Data
    qualificationDetails["tableHead"] = "Permanent Address"
    qualificationDetails["_blank1"] = " "
    qualificationDetails["_blank2"] = " "
    qualificationDetails["line1"] = "Line 1 : Address Line 1"
    qualificationDetails["line2"] = "Line 2 : Address Line 2"
    qualificationDetails["line3"] = "Line 3 : Address Line 3"
    
    
    // Pdf Code
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape
    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);
    doc.autoTable({ html: '#my-table' })
    doc.setFontSize(15);
    // const title = "My Awesome Report";
    // const headers = [["Col1", "Col2", "Col3", "Col4", "Col5", "Col6"]];
    var demoHeaders = []
    doc.text(firstName+' '+lastName, 280, 60, 'center');
   // doc.text('Candidate ID :'+respData.learnerID, 520, 100, 'right');
    // const ImageByteCode = "/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCACoAQ0DASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD7gooor70+PCiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKAP/Z"
    // doc.addImage(this.state.img, 'JPEG', 15, 40, 180, 180);

    // //const cans = this.getDataUrl(respData.profilePhotoURL);
    ///doc.addImage(dataURL, 'JPEG', 380,120,150,100);
    //doc.addImage("examples/images/Octonyan.jpg", "JPEG", 15, 40, 180, 180);
   
    // Personal Details
    doc.text('Personal Details ', 20, 100);
    const personalDetailsData = []
    const allPersonalDetailsData = personalDetail
    const allPersonalDetailsDataKeys = Object.keys(personalDetail)
    var flag=0
    var emptyList = []
    
    for(var i=0; i<=allPersonalDetailsDataKeys?.length; i++){
    if(flag > 1)
    {
    personalDetailsData.push(emptyList)
    emptyList = []
    flag = 0
    }
    flag = flag + 1
    emptyList.push(allPersonalDetailsData[allPersonalDetailsDataKeys[i]])
    
    }
    
    //demoHeaders = [["", ""]];
    var content = {
    styles : {rowHeight : 30,lineWidth : 1,
      // halign: 'center',
      // valign: 'middle'
    
    },
    startY: 110,
    theme: 'plain',
   // head: demoHeaders,
    body: personalDetailsData
    };

    // content = {
    //   styles :{
    //   lineWidth : 1,
    //   halign: 'center',
    //   valign: 'middle'
    //   },
    //   startY: doc.autoTable.previous.finalY+40,
    //   theme: 'plain',
    //   head: demoHeaders,
    //   body: ProfessionalQualificationDetailsData
    //   };
    doc.autoTable(content);
    
    // Address Details
    doc.text('Address Details ', 20, doc.autoTable.previous.finalY+20);
    // doc.setFontSize(12)
    // doc.text('Address Line 1 :  ', 40, doc.autoTable.previous.finalY+40);
    // Permanent Address
    const permanentAddressDetailsData = []
    const allpermanentAddressDetailsData = permanentaddressDetails
    const allpermanentAddressDetailsDataKeys = Object.keys(permanentaddressDetails)
    flag=0
    emptyList = []
    
    for(var i=0; i<=allpermanentAddressDetailsDataKeys?.length; i++){
    if(flag > 3)
    {
    permanentAddressDetailsData.push(emptyList)
    emptyList = []
    flag = 0
    }
    flag = flag + 1
    emptyList.push(allpermanentAddressDetailsData[allpermanentAddressDetailsDataKeys[i]])
    
    }


    
    //Demo Line 1
    doc.setFontSize(11)
    doc.text("Permanent Address", 40, doc.autoTable.previous.finalY+40)
    doc.setFontSize(15)
    var PermanentLineAddress = []
    var dummyLineData = {}
    var linedata = respData.address[1].street ? respData.address[1].street : ""
    dummyLineData["k1"] = "Address Line 1 : "+linedata
    PermanentLineAddress.push(dummyLineData)
    
    content = {
      styles : {rowHeight : 30  },
      startY: doc.autoTable.previous.finalY+75,
    theme: 'plain',
      body: PermanentLineAddress
    };
    //doc.autoTable(content);
    //Demo End

    //Demo Line 2
    PermanentLineAddress = []
      dummyLineData = {}
      linedata = respData.address[1].street2 ? respData.address[1].street2 : ""
      dummyLineData["k1"] = "Address Line 2 : "+linedata
      PermanentLineAddress.push(dummyLineData)
      content = {
        styles : {rowHeight : 30},
        startY: doc.autoTable.previous.finalY,
        theme: 'plain',
        body: PermanentLineAddress
      };
      //doc.autoTable(content);
    //Demo End

    //Demo Line 3
    PermanentLineAddress = []
    dummyLineData = {}
    linedata = respData.address[1].street3 ? respData.address[1].street3 : ""
    dummyLineData["k1"] = "Address Line 3 : "+linedata
    PermanentLineAddress.push(dummyLineData)
    content = {
      styles : {rowHeight : 30},
    startY: doc.autoTable.previous.finalY,
    theme: 'plain',
    body: PermanentLineAddress
    };
   // doc.autoTable(content);
    //Demo End
    
    // demoHeaders = [["Permanent Address", "", "", ""]];



    const peraddressDetailsData = []
    const perallAddressDetailsData = permanentaddressDetails
    const perallAddressDetailsDataKeys = Object.keys(permanentaddressDetails)
    var flag=0
    var emptyList = []
var flag=0
    var emptyList = []
    
    for(var i=0; i<=perallAddressDetailsDataKeys?.length; i++){
    if(flag > 1)
    {
      peraddressDetailsData.push(emptyList)
    emptyList = []
    flag = 0
    }
    flag = flag + 1
    emptyList.push(perallAddressDetailsData[perallAddressDetailsDataKeys[i]])
    
    }




    content = {
      styles : {rowHeight : 30,lineWidth : 1,
        // halign: 'center',
        // valign: 'middle'
      },
    startY: doc.autoTable.previous.finalY+50,
    theme: 'plain',
    // head: demoHeaders,
    body: peraddressDetailsData
    };




    doc.autoTable(content);
    
    // Correspondence Address
    const correspondenceAddressDetailsData = []
    const allcorrespondenceAddressDetailsData = tempaddressDetails
    const allcorrespondenceAddressDetailsDataKeys = Object.keys(tempaddressDetails)
    flag=0
    emptyList = []
    
    for(var i=0; i<=allcorrespondenceAddressDetailsDataKeys?.length; i++){
    if(flag > 3)
    {
    correspondenceAddressDetailsData.push(emptyList)
    emptyList = []
    flag = 0
    }
    flag = flag + 1
    emptyList.push(allcorrespondenceAddressDetailsData[allcorrespondenceAddressDetailsDataKeys[i]])
    
    }
    
    //Demo Line 1
    doc.setFontSize(11)
    doc.text("Correspondence Address", 40, doc.autoTable.previous.finalY+20)
    doc.setFontSize(15)
    var CorrespondenceLineAddress = []
    var dummyLineData = {}
    var linedata = respData.address[0].street ? respData.address[0].street : ""
    dummyLineData["k1"] = "Address Line 1 : "+linedata
    CorrespondenceLineAddress.push(dummyLineData)
    var dummyLineData = {}
   
      dummyLineData = {}
      linedata = respData.address[0].street2 ? respData.address[0].street2 : ""
      dummyLineData["k1"] = "Address Line 2 : "+linedata
      CorrespondenceLineAddress.push(dummyLineData)
     
    dummyLineData = {}
    linedata = respData.address[0].street3 ? respData.address[0].street3 : ""
    dummyLineData["k1"] = "Address Line 3 : "+linedata
    CorrespondenceLineAddress.push(dummyLineData)
    
    const addressDetailsData = []
    const allAddressDetailsData = tempaddressDetails
    const allAddressDetailsDataKeys = Object.keys(tempaddressDetails)
    var flag=0
    var emptyList = []
    for(var i=0; i<=allAddressDetailsDataKeys?.length; i++){
    if(flag > 1)
    {
      addressDetailsData.push(emptyList)
    emptyList = []
    flag = 0
    }
    flag = flag + 1
    emptyList.push(allAddressDetailsData[allAddressDetailsDataKeys[i]])
    
    }




    content = {
      styles : {rowHeight : 30,lineWidth : 1,
        // halign: 'center',
        // valign: 'middle'
      },
    startY: doc.autoTable.previous.finalY+40,
    theme: 'plain',
    // head: demoHeaders,
    body: addressDetailsData
    };

    
    doc.autoTable(content);
    
    doc.addPage()
    // Bank Details
    doc.text('Bank Details ', 30, 45);
    
   
    
    const bankDetailsData = []
    const allbankDetailsData = bankDetails
    const allbankDetailsDataKeys = Object.keys(bankDetails)
    flag=0
    emptyList = []
    for(var i=0; i<=allbankDetailsDataKeys?.length; i++){
    if(flag > 1)
    {
      bankDetailsData.push(emptyList)
    emptyList = []
    flag = 0
    }
    flag = flag + 1
    emptyList.push(allbankDetailsData[allbankDetailsDataKeys[i]])
    
    }
    
    //demoHeaders = [[""]];
    content = {
    styles : {
    rowHeight : 30,
   // cellPadding: 0.8,
    lineWidth : 1,
      // halign: 'center',
      // valign: 'middle'
    },
    startY: 60,
    theme: 'plain',
 //   head: demoHeaders,
    body: bankDetailsData
    };
    doc.autoTable(content);
    
    // JSON for test
    var testdata = {
    "responseObject" : [
    {
    "cpeDetail" : respData.learnerCpeDetails
    },
    {
    "qualification" : respData.learnerQualification
    },
    {
    "professionalQualification" : respData.learnerProfessionalQualification
    }
    ]
    }
    // JSON CPE Detail
    
    var cpeDetails = {}
    var cpeDetailJSON = testdata.responseObject[0].cpeDetail
    var cpeDetailsRows = testdata.responseObject[0].cpeDetail?.length
    // alert(cpeDetailsRows)
    for(var i=0; i<cpeDetailsRows; i++){
    const rowKeys = Object.keys(cpeDetailJSON[i])
    cpeDetails[i+"certNo"] = cpeDetailJSON[i].passingCertificateNo
    var dateChange =  cpeDetailJSON[i].dateOfPassingTest ? cpeDetailJSON[i].dateOfPassingTest.split(' ') : ''
    cpeDetails[i+"cteTestDate"] = dateChange[0]
    cpeDetails[i+"CPEcertNo"] = cpeDetailJSON[i].cpeCertificateNo
    dateChange = cpeDetailJSON[i].dateOfCpe ? cpeDetailJSON[i].dateOfCpe.split(' '):''
    cpeDetails[i+"dateOfCPE"] = dateChange[0]
    }
    
    // JSON Qualification
    
    var qualification = {}
    var qualificationDetailJSON = testdata.responseObject[1].qualification
    var qualificationDetailsRows = testdata.responseObject[1].qualification?.length
    // alert(cpeDetailsRows)
    for(var i=0; i<qualificationDetailsRows; i++){
    const rowKeys = Object.keys(qualificationDetailJSON[i])
    qualification[i+"University/College Name"] = qualificationDetailJSON[i].instituteName
    qualification[i+"Degree"] = qualificationDetailJSON[i].qualificationType
    qualification[i+"passingYear"] = qualificationDetailJSON[i].passingYear
    qualification[i+"CGPA"] = qualificationDetailJSON[i].percentage
    }
    
    // JSON ProfessionalQualification
    
    var professionalqualification = {}
    var professionalqualificationDetailJSON = testdata.responseObject[2].professionalQualification
    var professionalqualificationDetailsRows = testdata.responseObject[2].professionalQualification?.length
    // alert(cpeDetailsRows)
    for(var i=0; i<professionalqualificationDetailsRows; i++){
    const rowKeys = Object.keys(professionalqualificationDetailJSON[i])
    
    const occupaatn = this.getOccupation(professionalqualificationDetailJSON[i].occupation)
    professionalqualification[i+"occupation"] = occupaatn
    professionalqualification[i+"companyName"] = professionalqualificationDetailJSON[i].companyName
    professionalqualification[i+"designation"] = professionalqualificationDetailJSON[i].designation
    dateChange = professionalqualificationDetailJSON[i].fromDate ?  professionalqualificationDetailJSON[i].fromDate.split(' '): ''
    
    let d1=dateChange[0]!==undefined?dateChange[0].replaceAll('/','-'):''
    professionalqualification[i+"from"] =d1
    // moment(dateChange[0],"DD/MM/YYYY").format("DD-MM-YYYY")
    dateChange = professionalqualificationDetailJSON[i].toDate ? professionalqualificationDetailJSON[i].toDate.split(' ') : ''
    professionalqualification[i+"to"] = dateChange[0]!==undefined?dateChange[0].replaceAll('/','-'):""
  //  moment(dateChange[0],"DD/MM/YYYY").format("DD-MM-YYYY")
    professionalqualification[i+"totalExp"] = professionalqualificationDetailJSON[i].totalExperience
    const AnnualIncome = this.geIncomeDetails(professionalqualificationDetailJSON[i].annualIncome)

    professionalqualification[i+"annualIncome"] = AnnualIncome
    }
    
    
    // CPE Details
    if(respData.lookingFor==="1003"
    )
    {
   doc.text('NISM Certificate Details ', 40, doc.autoTable.previous.finalY+30);
    }
    const CPEDetailsData = []
    const allCPEDetailsData = cpeDetails
    const allCPEDetailsDataKeys = Object.keys(cpeDetails)
    flag=0
    emptyList = []
    
    for(var i=0; i<=allCPEDetailsDataKeys?.length; i++){
    if(flag > 3)
    {
    CPEDetailsData.push(emptyList)
    emptyList = []
    flag = 0
    }
    flag = flag + 1
    emptyList.push(allCPEDetailsData[allCPEDetailsDataKeys[i]])
    
    }
    
    
    demoHeaders = [["Passing Certificate No.", "Date of CPE Test", "CPE Certificate No", "Expiry Date of CPE"]];
    content = {
    styles :{
    lineWidth : 1,
    halign: 'center',
    valign: 'middle',
   
    },
    startY: doc.autoTable.previous.finalY+40,
    theme: 'plain',
    head: demoHeaders,
    body: CPEDetailsData
    };
    if(respData.lookingFor==="1003"
    )
    {
  doc.autoTable(content);
    }
    // Qualification Details
    doc.text('Educational Qualification Details ', 40, doc.autoTable.previous.finalY+30);
    
    const QualificationDetailsData = []
    const allQualificationDetailsData = qualification
    const allQualificationDetailsDataKeys = Object.keys(qualification)
    flag=0
    emptyList = []
    
    for(var i=0; i<=allQualificationDetailsDataKeys?.length; i++){
    if(flag > 3)
    {
    QualificationDetailsData.push(emptyList)
    emptyList = []
    flag = 0
    }
    flag = flag + 1
    emptyList.push(allQualificationDetailsData[allQualificationDetailsDataKeys[i]])
    
    }
    
    
    demoHeaders = [["University/College Name", "Degree", "Passing Year", "CGPA (%)"]];
    content = {
    styles :{
    lineWidth : 1,
    halign: 'center',
    valign: 'middle'
    },
    startY: doc.autoTable.previous.finalY+40,
    theme: 'plain',
    head: demoHeaders,
    body: QualificationDetailsData
    };
    doc.autoTable(content);
    
    // Professional Qualification Details
    doc.text('Professional Qualification Details ', 40, doc.autoTable.previous.finalY+30);
    
    const ProfessionalQualificationDetailsData = []
    const allprofessionalQualificationDetailsData = professionalqualification
    const allprofessionalQualificationDetailsDataKeys = Object.keys(professionalqualification)
    flag=0
    emptyList = []
    
    for(var i=0; i<=allprofessionalQualificationDetailsDataKeys?.length; i++){
    if(flag > 6)
    {
    ProfessionalQualificationDetailsData.push(emptyList)
    emptyList = []
    flag = 0
    }
    flag = flag + 1
    emptyList.push(allprofessionalQualificationDetailsData[allprofessionalQualificationDetailsDataKeys[i]])
    
    }
    
    
    demoHeaders = [["Occupation", "Company Name", "Designation", "From", "To", "Total Exp (in years)", "Annual Income"]];
    content = {
    styles :{
    lineWidth : 1,
    halign: 'center',
    valign: 'middle'
    },
    startY: doc.autoTable.previous.finalY+40,
    theme: 'plain',
    head: demoHeaders,
    body: ProfessionalQualificationDetailsData
    };
    doc.autoTable(content);
    
    
    // Save file
    doc.save(title1)
    if(i1+1===data1?.length){
      window.location.reload()
    }
  }
  //)

}
else{
  warning("Please select at least one record",warningNotification)
}
  }

  handleChange = selectedOption => {   
        this.setState(
      { selectedOption },
      () => console.log(`Option selected:`, this.state.selectedOption)
    );

  };

  filterCaseInsensitive = ({ id, value }, row) =>
    row[id] ? row[id].toLowerCase().includes(value.toLowerCase()) : true;


  handleClick = value => {
    if (value.loginAttempt < 3) {
      this.props.history.push("/admin-edit-user-profile", { role: value });
    }
    else {
      warning("User Account is blocked. You cannot Edit the profile", warningNotification);
    }

  };
  toggleSelectAll() {
    let newSelected = {};
   // let data = []
    let temp_data = []
    let  mailData=[]
    let smsData=[]
    let smsDataProfile=[]
    let exportData=[]
    if (this.state.selectAll === 0) {
      this.props.distributorProfileUser.forEach(x => {
        let obj = {}
        let smsProfile ={}
        let obj1 = {}
        newSelected[x.learnerPartyID] = true;
          obj1['emailId'] = x.emailID
          obj1['userName'] = x.firstName
          obj1['password'] =""
          obj1['templateId'] = "196043"
          obj1['status'] =  "NISM_Profiles_Created"   
          obj1['partyId'] = x.learnerPartyID

          smsProfile['userName'] = x.firstName
          smsProfile['templateId'] = "4006"
          smsProfile['mobileNumber'] = x.mobileNo
          smsProfile['status'] =  "NISM_Profiles_Created"     
          smsProfile['partyId'] = x.learnerPartyID

              obj= {
                   // "action":x.learnerWorkflowMap[0]? x.learnerWorkflowMap[0].status.toUpperCase()==="NISM VA PAYMENT COMPLETED"?"NISM PROFILE CREATE":x.learnerWorkflowMap[0].status.toUpperCase():'',

                    "action":x.learnerWorkflowMap[0]? x.learnerWorkflowMap[0].status.toUpperCase()==="NISM VA PAYMENT COMPLETED"?"NISM PROFILE CREATE":x.learnerWorkflowMap[0].status.toUpperCase()==="KYD-ARN APPLIED"?"KYD-ARN ACCEPT":x.learnerWorkflowMap[0].status.toUpperCase()==="UNDER EMPANELMENT"?"EMPANEL":x.learnerWorkflowMap[0].status.toUpperCase():'',

                    "workflowId": x.learnerID,
                    "workflowName": x.lookingFor==="1001"?"ARN":"ARN",
                    "comment": ""
                }
               
            
        
          temp_data.push(obj)
          mailData.push(obj1)
          exportData.push(x)
          smsDataProfile.push(smsProfile)
      });
    }

    this.setState({
      selected: newSelected,
      selectAll: this.state.selectAll === 0 ? 1 : 0,
      data: temp_data,
      exportData:exportData
    });
  }


  renderEditableDownload = cellInfo => {

    if (cellInfo) {
      

   let currentValue = cellInfo.original ? cellInfo.original.hasOwnProperty('applicationStatus') === false ? "" : cellInfo.original.applicationStatus ? cellInfo.original.applicationStatus: '' : ''
        const cellValue = this.props.distributorProfileUser === null ? '' : this.props.distributorProfileUser[cellInfo.index] === undefined ? "" : this.props.distributorProfileUser[cellInfo.index][cellInfo.column.id] == undefined ? "" : this.props.distributorProfileUser[cellInfo.index][cellInfo.column.id];

        return (
            <div>

                <select name="download" id="download" value={cellValue}
                    onChange={this.handleInputChangeDownload.bind(null, cellInfo)}
                    disabled={(currentValue==="REGISTERED" || currentValue==="DRAFTED")?true:false}
// disabled={currentValue==="DRAFTED"?true:false}
                >
                    <option value="">Select</option>
                    <option value="All">All</option>
                    <option value="Pan">PAN</option>
                    {/* <option value="Aadhar">Aadhaar front part</option>
                    <option value="Aadharback">Aadhaar back part</option> */}
                    <option value="Profile">Profile Photo</option>
                    <option value="POA">Proof Of Address</option>
                    {/* <option value="Resume">Resume</option> */}
                </ select>
                {/* <i class="fa fa-ellipsis-h actionIcon" aria-hidden="true"></i> */}
            </div>
        );
    }
    else {
        return ('')
    }
};
  handleInputChangeDownload = (cellInfo, event) => {

    let temp = []
    let data1 = [...this.props.distributorProfileUser];
    data1[cellInfo.index][cellInfo.column.id] = event.target.value;
    temp.push(cellInfo.original)
    this.setState({ dataChange: temp });


    let name1 = event.target.value;

    if(name1 === "All"){
      this.downloadURI(cellInfo.original, event.target.value)
    } else {

    console.log("cellInfo.original", cellInfo.original)
    console.log("event.target.value", event.target.value)

    let DocId = ""
    let documentUrl = ""

    if (name1 == "Pan") {
      if (cellInfo.original.panCardDocId === undefined) {
        warning("No document available", warningNotification)
      }
      else {
        DocId = cellInfo.original.panCardDocId
      }
    }
    else if (name1 == "Aadharback") {
      if (cellInfo.original.aadharCardBackDocId === undefined) {
        warning("No document available", warningNotification)
      }
      else {
        DocId = cellInfo.original.aadharCardBackDocId
      }
    }
    else if (name1 == "Aadhar") {
      if (cellInfo.original.aadharCardDocId === undefined) {
        warning("No document available", warningNotification)
      }
      else {
        DocId = cellInfo.original.aadharCardDocId
      }
    }
    else if (name1 == "Profile") {
      if (cellInfo.original.profilePhotoDocId === undefined) {
        warning("No document available", warningNotification)
      }
      else {
        DocId = cellInfo.original.profilePhotoDocId
      }
    }else if (name1 == "POA") {
      if (cellInfo.original.proofOfAddressDocId === undefined) {
        warning("No document available", warningNotification);
      } else {
        DocId = cellInfo.original.proofOfAddressDocId;
      }
    }


    let data = cellInfo.original
    let name = event.target.value

    RegisterUserService.downloadDocumet("documentId=" + DocId + "&bucketTag=" + Global_var.CONST_BUCKET_NAME, docRes => {
      if (docRes.status == "success") {
        documentUrl = docRes.responseObject.documentUrl
        // this.downloadURI(cellInfo.original, event.target.value, documentUrl)
        this.downloadURIDoc(data, name, documentUrl)
      }
    })

  }

  };

  downloadURIDoc(data, name1, documentUrl) {
    let uri = ""
    let name = ""
    if (name1 == "Pan") {
        if (documentUrl === undefined) {
            uri = "#"
            warning("No document available", warningNotification)
        }
        else {
            uri = documentUrl === undefined ? "#" : documentUrl
            name = "PAN Card"
  
        }
    }
    else if (name1 == "Aadhar") {
        uri = documentUrl
        name = "Aadhar Card"
    }
    else if (name1 == "Aadharback") {
        uri = documentUrl
        name = "Aadhar Card Back"
    }
    else if(name1 =="Profile"){
      uri = documentUrl
      name = "Profile"
    }
    else if (name1 == "POA") {
      uri = documentUrl;
      name = "POA";
    }
    else if(name1 =="Resume"){
      if(documentUrl){
        uri=documentUrl
      }else{
        uri = "#"
  warning("Resume not uploaded",warningNotification)
      }
     
      name="Resume"
    }
    else {
        // uri = "#"
        // warning("Coming Soon", warningNotification)
        let data1 = {
            "partyId": data.learnerPartyID
  
        }
        this.setState({
            loading: true
        })
  
        RegisterUserService.downloadZip(data1, res => {
  
            if (res.responseObject.documentId !== 0) {
                let DocId = res.responseObject.documentId
                RegisterUserService.downloadDocumet("documentId=" + DocId + "&bucketTag="+Global_var.CONST_BUCKET_NAME, res1 => {
                    this.setState({
                        loading: false
                    })
                    window.location.href = res1.responseObject.documentUrl
  
                })
  
            }
            else {
                this.setState({
                    loading: false
                })
                warning("No document available", warningNotification)
            }
  
        })
  
    }
  
  
    if (name1 == "Pan" || name1 == "Aadhar" || name1 == "Aadharback" || name1=="Profile" || name1=="Resume" ||
    name1 == "POA") {
  
  
        window.location.href = uri
    }
  
  }

downloadURI(data, name1) {
  let uri = ""
  let name = ""

  if (name1 == "Pan") {
      if (data.panCardURL === undefined) {
          uri = "#"
          warning("No document available", warningNotification)
      }
      else {
          uri = data.panCardURL === undefined ? "#" : data.panCardURL
          name = "PAN Card"

      }
  }
  else if (name1 == "Aadhar") {
      uri = data.aadharCardURL
      name = "Aadhar Card"
  }
  else if (name1 == "Aadharback") {
      uri = data.aadharCardBackURL
      name = "Aadhar Card Back"
  }
  else if(name1 =="Profile"){
    uri = data.profilePhotoURL
    name = "Profile"
  }
  else if(name1 =="Resume"){
    if(data.hasOwnProperty("resumeDocumentURL")){
      uri=data.resumeDocumentURL
    }else{
      uri = "#"
warning("Resume not uploaded",warningNotification)
    }
   
    name="Resume"
  }
  else {
      // uri = "#"
      // warning("Coming Soon", warningNotification)
      let data1 = {
          "partyId": data.learnerPartyID

      }
      this.setState({
          loading: true
      })

      RegisterUserService.downloadZip(data1, res => {
          if (res.responseObject.documentId !== 0) {
              let DocId = res.responseObject.documentId
              RegisterUserService.downloadDocumet("documentId=" + DocId + "&bucketTag="+Global_var.CONST_BUCKET_NAME, res1 => {
                  this.setState({
                      loading: false
                  })
                  window.location.href = res1.responseObject.documentUrl

              })

          }
          else {
              this.setState({
                  loading: false
              })
              warning("No document available", warningNotification)
          }

      })

  }


  if (name1 == "Pan" || name1 == "Aadhar" || name1 == "Aadharback" || name1=="Profile" || name1=="Resume") {


      window.location.href = uri
  }

}


  toggleRow(original) {
    
    // emailID
    
    let data = this.state.data
    let temp_data = []
    let  mailData=[]
    let smsDataProfile=[]
    let exportData = this.state.exportData
    let AllData = []
    let obj1 = {}
    let obj2 = {}
    let sms = {}
    let smsProfile ={}
    let mailDataAmc1=this.state.mailDataAmc
    let mailDataKYD=this.state.mailDataKYD
    let smsData=this.state.smsData
    let smsEmpanelmentData = this.state.smsEmpanelmentData
    let flag=true
    let isData=this.state.isData
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[original.learnerPartyID] = !this.state.selected[original.learnerPartyID];
    //data.push(original)
    // this.setState({
    //     selected: newSelected,

    // });
    this.state.data.map((e,i)=>{
     if(e.learnerPartyID == original.learnerPartyID)
     {
      data.splice(i, 1);
      exportData.splice(i, 1)
       flag=false;
      
       if(data?.length==0)
       {
        isData=true
       }
      
   
     }
    })
    if (data?.length > 0 && isData==false) {
      this.setState({
        isData:false,
             
            
            });
   
        if(flag==true)
        {
        //   data.splice(i, 1);
        // } else {
          obj1['emailId'] = original.emailID
          obj1['userName'] = original.firstName
          obj1['password'] =""
          obj1['templateId'] = "196043"
          obj1['status'] =  "NISM_Profiles_Created"     
          obj1['partyId'] = original.learnerPartyID

          smsProfile['userName'] = original.firstName
          smsProfile['templateId'] = "4006"
          smsProfile['mobileNumber'] = original.mobileNo
          smsProfile['status'] =  "NISM_Profiles_Created"     
          smsProfile['partyId'] = original.learnerPartyID

          obj2['emailId'] = original.emailID
          obj2['userName'] = original.firstName
          obj2['password'] =""
          obj2['templateId'] = "198090"
          obj2['status'] =  "KYD-ARN APPLIED"     
          obj2['partyId'] = original.learnerPartyID
          obj2['mobileNumber'] = original.mobileNo
          obj2["learnerId"]=original.learnerID
         
          sms['userName'] = original.firstName
          sms['templateId'] = "4012"
          sms['mobileNumber'] = original.mobileNo
          sms['status'] =  "KYD-ARN ACCEPTED"     
          sms['partyId'] = original.learnerPartyID
           
             let obj= {
                   // "action":original.learnerWorkflowMap[0]? original.learnerWorkflowMap[0].status.toUpperCase()==="NISM VA PAYMENT COMPLETED"?"NISM PROFILE CREATE":original.learnerWorkflowMap[0].status.toUpperCase():original.learnerWorkflowMap[0].status.toUpperCase()==="KYD-ARN APPLIED"?"KYD-ARN ACCEPTE":"",
                   "action":original.learnerWorkflowMap[0]? original.learnerWorkflowMap[0].status.toUpperCase()==="NISM VA PAYMENT COMPLETED"?"NISM PROFILE CREATE":original.learnerWorkflowMap[0].status.toUpperCase()==="KYD-ARN APPLIED"?"KYD-ARN ACCEPT":original.learnerWorkflowMap[0].status.toUpperCase()==="UNDER EMPANELMENT"?"EMPANEL":original.learnerWorkflowMap[0].status.toUpperCase():'',

                    "workflowId": original.learnerID,
                    "workflowName": original.lookingFor==="1001"?"ARN":"ARN",
                    "comment": "",
                    "learnerPartyID":original.learnerPartyID
                }
                let mailDataAmc=
                  {
                  "userName": original.firstName,
                  "templateId": "196069",
                  "emailId": original.emailID,
                  "status": "Empanelment Accepted",
                  "partyId":original.learnerPartyID,
                  "learnerId":original.learnerID,
                  "panNumber":original.panNo,
                  "amcName":localStorage.getItem('amcId')
                  
                  }
                  let smsEmpanelment ={              
                      "userName": original.firstName,
                      "templateId": "4014",
                      "mobileNumber": original.mobileNo,
                      "status": 'EMPANELLED',
                      "partyId": original.learnerID,   
                  }

                  mailDataAmc1.push(mailDataAmc)
                  mailDataKYD.push(obj2)
                  smsData.push(sms)
                  smsDataProfile.push(smsProfile)
                  smsEmpanelmentData.push(smsEmpanelment)
                  AllData.push(original)
                  temp_data.push(obj)
                  mailData.push(obj1)
               // smsData.push(sms)

        }
     // }
    }
    else {
          obj1['emailId'] = original.emailID
          obj1['userName'] = original.firstName
          obj1['password'] =""
          obj1['templateId'] = "196043"
          obj1['status'] =  "NISM_Profiles_Created"   
          obj1['partyId'] = original.learnerPartyID

          smsProfile['userName'] = original.firstName
          smsProfile['templateId'] = "4006"
          smsProfile['mobileNumber'] = original.mobileNo
          smsProfile['status'] =  "NISM_Profiles_Created"     
          smsProfile['partyId'] = original.learnerPartyID

          obj2['emailId'] = original.emailID
          obj2['userName'] = original.firstName
          obj2['password'] =""
          obj2['templateId'] = "198090"
          obj2['status'] =  "KYD-ARN APPLIED" 
          obj2['partyId'] = original.learnerPartyID
          obj2['mobileNumber'] = original.mobileNo
          obj2["learnerId"]=original.learnerID

          sms['userName'] = original.firstName
          sms['templateId'] = "4012"
          sms['mobileNumber'] = original.mobileNo
          sms['status'] =  "KYD-ARN ACCEPTED"     
          sms['partyId'] = original.learnerPartyID

      let obj= {
      //  "action":original.learnerWorkflowMap[0]? original.learnerWorkflowMap[0].status.toUpperCase()==="NISM VA PAYMENT COMPLETED"?"NISM PROFILE CREATE":original.learnerWorkflowMap[0].status.toUpperCase()==="KYD-ARN APPLIED"?"KYD-ARN ACCEPT":"":'',
//original.learnerWorkflowMap[0]? original.learnerWorkflowMap[0].status.toUpperCase()==="NISM VA PAYMENT COMPLETED"?"NISM PROFILE CREATE":original.learnerWorkflowMap[0].status.toUpperCase():'',
        "action":original.learnerWorkflowMap[0]? original.learnerWorkflowMap[0].status.toUpperCase()==="NISM VA PAYMENT COMPLETED"?"NISM PROFILE CREATE":original.learnerWorkflowMap[0].status.toUpperCase()==="KYD-ARN APPLIED"?"KYD-ARN ACCEPT":original.learnerWorkflowMap[0].status.toUpperCase()==="UNDER EMPANELMENT"?"EMPANEL":original.learnerWorkflowMap[0].status.toUpperCase():'',
        "workflowId": original.learnerID,
        "workflowName": original.lookingFor==="1001"?"ARN":"ARN",
        "comment": "",
        "learnerPartyID":original.learnerPartyID
    }
    let mailDataAmc=
      {
      "userName": original.firstName,
      "templateId": "196069",
      "emailId": original.emailID,
      "status": "Empanelment Accepted",
      "partyId":original.learnerPartyID,
      "learnerId":original.learnerID,
      "panNumber":original.panNo,
      "amcName":localStorage.getItem('amcId')
      
      }
      let smsEmpanelment ={              
        "userName": original.firstName,
        "templateId": "4014",
        "mobileNumber": original.mobileNo,
        "status": 'EMPANELLED',
        "partyId": original.learnerID,   
    }
      mailDataAmc1.push(mailDataAmc)
      AllData.push(original)
      temp_data.push(obj)
      mailData.push(obj1)
      mailDataKYD.push(obj2)
      smsData.push(sms)
      smsDataProfile.push(smsProfile)
      smsEmpanelmentData.push(smsEmpanelment)
    }
    
    console.log(data)
    let d1 = data.concat(temp_data)
    let exportData1 = exportData.concat(AllData)
      this.setState({
        selected: newSelected,
        data: d1,
        selectAll: isData==false?2:0,
        mailData:mailData,
        exportData: exportData1,
        mailDataKYD:mailDataKYD,
        smsData:smsData,
        smsDataProfile:smsDataProfile
      });
   
    
   
    console.log('dataaaaaaaaaaaaaaaaaaaaaaa')
    console.log(this.state.data)
  }

  WorkflowUpdate= () =>{
   
      this.setState({
        isAllow:false
      })
    
    if(this.state.data?.length>0)
    {
    let flag=true
   let workflowtemp={
    "ExcecutionTracker":this.state.data
   }
   console.log(this.state.data)
  this.state.data.map(e=>{
   if(e.action!=="NISM PROFILE CREATE"){
     flag=false
   }
  })
  if(flag==true )
  {
    
    updateStatus(workflowtemp, res1 => {
      if(res1.status=="fail")
      {
        warning(res1.reasonText, successNotification);
      }
      else{
      success("NISM Profile Created Successfully.", successNotification);
      setTimeout(() => {
        window.location.reload();
                        }, 5000)
                        
                        RegisterUserService.sendSms(this.state.smsDataProfile, res3 => {
                          this.setState({ smsDataProfile: [] })
                          //success("Feat completed successfully.", successNotification);
                          // if(res3.status === "success"){
                          //     success("NISM Profile Created Successfully- DistributorListBySearch sms sent", successNotification);
                          // } else {
                          //     error("NISM Profile Created Successfully- DistributorListBySearch sms failed .", errorNotification);
                          // }
                      })

          // RegisterUserService.sendMail(this.state.mailData, res2 => {
          // this.setState({ mailData: [] })
          //      this.setState({ data: [] })
          // })
    }
    })
  }
  else{
  
    warning("Action is invalid for Selected Distributors Current Stage should be NISM VA Payment completed", warningNotification)
   // window.location.reload()
   

  }
}else{
  warning("Please select at least one record.", warningNotification)
}

  }
  titleCase(str) {

    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });

}
  exportExcelUserProfile = () => {
    debugger;
    let modifiedData = [];
    // let data = this.props.distributorProfileUser;
    // if (data !== null) {
    let cityName = ''
    let NameofExacel = ""
    let data = this.state.exportData?.length > 0 ? this.state.exportData : []
    if (data?.length > 0) {
      //data1.map(respData=>{

      for (let i1 = 0; i1 < data?.length; i1++) {

        let element = data[i1]
        //  data.forEach((element,index) => {
        if (element.address?.length > 0) {
          // for (let i = 0; i < this.state.allCityList?.length; i++) {
          //   if (this.state.allCityList[i].cityId === element.address[0].cityId) {
          //     cityName= this.titleCase(this.state.allCityList[i].cityName)
          //   } else {
          //     cityName= ""
          //   }
          // }
        }
        //  alert(element.learnerType)
        NameofExacel = element.firstName + " " + element.lastName
        let state = element.address[0].stateId ? element.address[0].stateId : ""
        let stateName = this.getState(state)


        let cityDetails = element.address[0].cityId ? element.address[0].cityId : "";
        let cityName = this.getCity(cityDetails)



        const gender = element.gender === 1 ? "Male" : "Female"
        var data1 = {
          //"Sr. No.":index+1,
          "Who are you": element.learnerType === 1011 ? "Student" : element.learnerType === 1012 ? "Self Employed" : element.learnerType === 1013 ? "Professional" : element.learnerType === 1014 ? "Home Maker" : element.learnerType === 1015 ? "Retired" : '',
          "College Name": element.collegeName!==undefined? element.collegeName:"-",
          "FINX Internship": element.isFinXInternship===1?"Yes":element.isFinXInternship===0?"No":"Not Applicable",
          "Current Profession": "",
          "Email Id": element.emailID,
          // "Title":"User Profile",
          "First Name": element.firstName,
          "Middle Name": element.middleName,
          "Last Name": element.lastName,
          "Father's Name": element.learnerFatherName,
          "Date of birth": element.dob ? moment(element.dob.split(" ")[0], "DD/MM/YYYY").format("DD-MM-YYYY"): '',
          "Gender": gender,
          "PAN Number": element.panNumber,
          //"Aadhaar Number": element.aadharNumber,
          "Address Line 1": element.address[0].street,
          "Address Line 2": element.address[0].street2,
          "Address Line 3": element.address[0].street3,
          "City": cityName,
          "Pincode": element.address[0].postalCode,
          "State": this.titleCase(stateName),
          "Mobile Number": element.mobileNo,
          "IFSC Code": element.ifscCode,
          "Bank Name": element.bankName,
          "Branch Name": element.branchName,
          "Branch Address": element.branchAddress,
          //"Account Type":element.accountType==1?"Saving":"Current",
          "Account Type": element.accountType == 1 ? "Saving" : "",
          "Account Number": element.accountNumber,
          "Is Amfi User": element.isAmfiUser===0?"No":'Yes',
          "Nominee Name": element.hasOwnProperty("nomineeName") ? element.nomineeName : "",

          "Nominee Address": element.hasOwnProperty("nomineeAddress") ? element.nomineeAddress : '',
          "Relationship With The Distributer": element.hasOwnProperty("relationshipWithTheDistributer") ? element.relationshipWithTheDistributer : '',
          "Institute Name 1": element.learnerQualification?.length > 0 ? element.learnerQualification[0].instituteName : '',
          "Qualification Type 1": element.learnerQualification?.length > 0 ? element.learnerQualification[0].qualificationType : '',
          "Passing Year 1": element.learnerQualification?.length > 0 ? element.learnerQualification[0].passingYear : '',
          "Percentage 1": element.learnerQualification?.length > 0 ? element.learnerQualification[0].percentage : '',

          "Institute Name 2": element.learnerQualification?.length > 1 ? element.learnerQualification[1].instituteName : '',
          "Qualification Type 2": element.learnerQualification?.length > 1 ? element.learnerQualification[1].qualificationType : '',
          "Passing Year 2": element.learnerQualification?.length > 1 ? element.learnerQualification[1].passingYear : '',
          "Percentage 2": element.learnerQualification?.length > 1 ? element.learnerQualification[1].percentage : '',




          "Institute Name 2": element.learnerQualification?.length > 1 ? element.learnerQualification[1].instituteName : '',
          "Qualification Type 2": element.learnerQualification?.length > 1 ? element.learnerQualification[1].qualificationType : '',
          "Passing Year 2": element.learnerQualification?.length > 1 ? element.learnerQualification[1].passingYear : '',
          "Percentage 2": element.learnerQualification?.length > 1 ? element.learnerQualification[1].percentage : '',


          "Institute Name 3": element.learnerQualification?.length > 2 ? element.learnerQualification[2].instituteName : '',
          "Qualification Type 3": element.learnerQualification?.length > 2 ? element.learnerQualification[2].qualificationType : '',
          "Passing Year 3": element.learnerQualification?.length > 2 ? element.learnerQualification[2].passingYear : '',
          "Percentage 3": element.learnerQualification?.length > 2 ? element.learnerQualification[2].percentage : '',


          "Institute Name 4": element.learnerQualification?.length > 3 ? element.learnerQualification[3].instituteName : '',
          "Qualification Type 4": element.learnerQualification?.length > 3 ? element.learnerQualification[3].qualificationType : '',
          "Passing Year 4": element.learnerQualification?.length > 3 ? element.learnerQualification[3].passingYear : '',
          "Percentage 4": element.learnerQualification?.length > 3 ? element.learnerQualification[3].percentage : '',



          "Institute Name 5": element.learnerQualification?.length > 4 ? element.learnerQualification[4].instituteName : '',
          "Qualification Type 5": element.learnerQualification?.length > 4 ? element.learnerQualification[4].qualificationType : '',
          "Passing Year 5": element.learnerQualification?.length > 4 ? element.learnerQualification[4].passingYear : '',
          "Percentage 5": element.learnerQualification?.length > 4 ? element.learnerQualification[4].percentage : '',


          "Institute Name 6": element.learnerQualification?.length > 5 ? element.learnerQualification[5].instituteName : '',
          "Qualification Type 6": element.learnerQualification?.length > 5 ? element.learnerQualification[5].qualificationType : '',
          "Passing Year 6": element.learnerQualification?.length > 5 ? element.learnerQualification[5].passingYear : '',
          "Percentage 6": element.learnerQualification?.length > 5 ? element.learnerQualification[5].percentage : '',


          "Institute Name 7": element.learnerQualification?.length > 6 ? element.learnerQualification[6].instituteName : '',
          "Qualification Type 7": element.learnerQualification?.length > 6 ? element.learnerQualification[6].qualificationType : '',
          "Passing Year 7": element.learnerQualification?.length > 6 ? element.learnerQualification[6].passingYear : '',
          "Percentage 7": element.learnerQualification?.length > 6 ? element.learnerQualification[6].percentage : '',







          "Company Name 1": element.learnerProfessionalQualification?.length > 0 ? element.learnerProfessionalQualification[0].companyName : '',
          "Designation 1": element.learnerProfessionalQualification?.length > 0 ? element.learnerProfessionalQualification[0].designation : '',
          "Occupation 1": element.learnerProfessionalQualification?.length > 0 ? this.getOccupation(element.learnerProfessionalQualification[0].occupation) : '',
          "FromDate 1": element.learnerProfessionalQualification?.length > 0 ? element.learnerProfessionalQualification[0].fromDate : '',
          "To Date 1": element.learnerProfessionalQualification?.length > 0 ? element.learnerProfessionalQualification[0].toDate : '',
          "Total Experience 1": element.learnerProfessionalQualification?.length > 0 ? element.learnerProfessionalQualification[0].totalExperience : '',



          "Company Name 2": element.learnerProfessionalQualification?.length > 1 ? element.learnerProfessionalQualification[1].companyName : '',
          "Designation 2": element.learnerProfessionalQualification?.length > 1 ? element.learnerProfessionalQualification[1].designation : '',
          "Occupation 2": element.learnerProfessionalQualification?.length > 1 ? this.getOccupation(element.learnerProfessionalQualification[1].occupation) : '',
          "From Date 2": element.learnerProfessionalQualification?.length > 1 ? element.learnerProfessionalQualification[1].fromDate : '',
          "To Date 2": element.learnerProfessionalQualification?.length > 1 ? element.learnerProfessionalQualification[1].toDate : '',
          "Total Experience 2": element.learnerProfessionalQualification?.length > 1 ? element.learnerProfessionalQualification[1].totalExperience : '',




          "Company Name 3": element.learnerProfessionalQualification?.length > 2 ? element.learnerProfessionalQualification[2].companyName : '',
          "Designation 3": element.learnerProfessionalQualification?.length > 2 ? element.learnerProfessionalQualification[2].designation : '',
          "Occupation 3": element.learnerProfessionalQualification?.length > 2 ? this.getOccupation(element.learnerProfessionalQualification[2].occupation) : '',
          "From Date 3": element.learnerProfessionalQualification?.length > 2 ? element.learnerProfessionalQualification[2].fromDate : '',
          "To Date 3": element.learnerProfessionalQualification?.length > 2 ? element.learnerProfessionalQualification[2].toDate : '',
          "Total Experience 3": element.learnerProfessionalQualification?.length > 2 ? element.learnerProfessionalQualification[2].totalExperience : '',




          "Company Name 4": element.learnerProfessionalQualification?.length > 3 ? element.learnerProfessionalQualification[3].companyName : '',
          "Designation 4": element.learnerProfessionalQualification?.length > 3 ? element.learnerProfessionalQualification[3].designation : '',
          "Occupation 4": element.learnerProfessionalQualification?.length > 3 ? this.getOccupation(element.learnerProfessionalQualification[3].occupation) : '',
          "From Date 4": element.learnerProfessionalQualification?.length > 3 ? element.learnerProfessionalQualification[3].fromDate : '',
          "To Date 4": element.learnerProfessionalQualification?.length > 3 ? element.learnerProfessionalQualification[3].toDate : '',
          "Total Experience 4": element.learnerProfessionalQualification?.length > 3 ? element.learnerProfessionalQualification[3].totalExperience : '',




          "Company Name 5": element.learnerProfessionalQualification?.length > 4 ? element.learnerProfessionalQualification[4].companyName : '',
          "Designation 5": element.learnerProfessionalQualification?.length > 4 ? element.learnerProfessionalQualification[4].designation : '',
          "Occupation 5": element.learnerProfessionalQualification?.length > 4 ? this.getOccupation(element.learnerProfessionalQualification[4].occupation) : '',
          "From Date 5": element.learnerProfessionalQualification?.length > 4 ? element.learnerProfessionalQualification[4].fromDate : '',
          "To Date 5": element.learnerProfessionalQualification?.length > 4 ? element.learnerProfessionalQualification[4].toDate : '',
          "Total Experience 5": element.learnerProfessionalQualification?.length > 4 ? element.learnerProfessionalQualification[4].totalExperience : '',



          "Company Name 6": element.learnerProfessionalQualification?.length > 5 ? element.learnerProfessionalQualification[5].companyName : '',
          "Designation 6": element.learnerProfessionalQualification?.length > 5 ? element.learnerProfessionalQualification[5].designation : '',
          "Occupation 6": element.learnerProfessionalQualification?.length > 5 ? this.getOccupation(element.learnerProfessionalQualification[5].occupation) : '',
          "From Date 6": element.learnerProfessionalQualification?.length > 5 ? element.learnerProfessionalQualification[5].fromDate : '',
          "To Date 6": element.learnerProfessionalQualification?.length > 5 ? element.learnerProfessionalQualification[5].toDate : '',
          "Total Experience 6": element.learnerProfessionalQualification?.length > 5 ? element.learnerProfessionalQualification[5].totalExperience : '',




          "Company Name 7": element.learnerProfessionalQualification?.length > 6 ? element.learnerProfessionalQualification[6].companyName : '',
          "Designation 7": element.learnerProfessionalQualification?.length > 6 ? element.learnerProfessionalQualification[6].designation : '',
          "Occupation 7": element.learnerProfessionalQualification?.length > 6 ? this.getOccupation(element.learnerProfessionalQualification[6].occupation) : '',
          "From Date 7": element.learnerProfessionalQualification?.length > 6 ? element.learnerProfessionalQualification[6].fromDate : '',
          "To Date 7": element.learnerProfessionalQualification?.length > 6 ? element.learnerProfessionalQualification[6].toDate : '',
          "Total Experience 7": element.learnerProfessionalQualification?.length > 6 ? element.learnerProfessionalQualification[6].totalExperience : '',




          "Company Name 8": element.learnerProfessionalQualification?.length > 7 ? element.learnerProfessionalQualification[7].companyName : '',
          "Designation 8": element.learnerProfessionalQualification?.length > 7 ? element.learnerProfessionalQualification[7].designation : '',
          "Occupation 8": element.learnerProfessionalQualification?.length > 7 ? this.getOccupation(element.learnerProfessionalQualification[7].occupation) : '',
          "From Date 8": element.learnerProfessionalQualification?.length > 7 ? element.learnerProfessionalQualification[7].fromDate : '',
          "To Date 8": element.learnerProfessionalQualification?.length > 7 ? element.learnerProfessionalQualification[7].toDate : '',
          "Total Experience 8": element.learnerProfessionalQualification?.length > 7 ? element.learnerProfessionalQualification[7].totalExperience : '',




          "Company Name 9": element.learnerProfessionalQualification?.length > 8 ? element.learnerProfessionalQualification[8].companyName : '',
          "Designation 9": element.learnerProfessionalQualification?.length > 8 ? element.learnerProfessionalQualification[8].designation : '',
          "Occupation 9": element.learnerProfessionalQualification?.length > 8 ? this.getOccupation(element.learnerProfessionalQualification[8].occupation) : '',
          "From Date 9": element.learnerProfessionalQualification?.length > 8 ? element.learnerProfessionalQualification[8].fromDate : '',
          "To Date 9": element.learnerProfessionalQualification?.length > 8 ? element.learnerProfessionalQualification[8].toDate : '',
          "Total Experience 9": element.learnerProfessionalQualification?.length > 8 ? element.learnerProfessionalQualification[8].totalExperience : '',




          "Company Name 10": element.learnerProfessionalQualification?.length > 9 ? element.learnerProfessionalQualification[9].companyName : '',
          "Designation 10": element.learnerProfessionalQualification?.length > 9 ? element.learnerProfessionalQualification[9].designation : '',
          "Occupation 10": element.learnerProfessionalQualification?.length > 9 ? this.getOccupation(element.learnerProfessionalQualification[9].occupation) : '',
          "From Date 10": element.learnerProfessionalQualification?.length > 9 ? element.learnerProfessionalQualification[9].fromDate : '',
          "To Date 10": element.learnerProfessionalQualification?.length > 9 ? element.learnerProfessionalQualification[9].toDate : '',
          "Total Experience 10": element.learnerProfessionalQualification?.length > 9 ? element.learnerProfessionalQualification[9].totalExperience : ''


        };
        modifiedData.push(data1);
        // });


        // let d2 = date1

        //    let title = "Feat-List-" + time2 + "-"
        // let title1 = "ExpertMFD-DateRequest-List-" + date1 + "-" + time2 + ".pdf"
        //let title1="Distributor-List-"+ date1 + "-" + time2 + ".pdf"
        // let date=new Date();
        // let title1="ExpertMFD-DistributorList-"+date
        // doc.save(title)

        // if(i1+1===data?.length){
        //   window.location.reload()
        // }
      }
      let date = new Date();
      let time = new Date().toLocaleString().split(",")[1]

      let time1 = time.split(" ")[2]
      let time2 = time.split(":")[0] + "-" + time.split(":")[1] + "-" + time1
      ///  alert(time)
      time2 = time2.split(" ")[1]

      let date1 = moment(date).format("DD-MM-YYYY")
      let title1 = "Distributor-profile" + time2

      ExcelService.ExcelData(modifiedData, title1);
    }
    //}
    else {
      warning("Select atleast one record", warningNotification)
    }

  }
  KYDWorkflowUpdate= () =>{
   
    this.setState({
      isAllow:false
    })
  
  if(this.state.data?.length>0)
  {
  let flag=true
 let workflowtemp={
  "ExcecutionTracker":this.state.data
 }
 console.log(this.state.data)
this.state.data.map(e=>{
 if(e.action!=="KYD-ARN ACCEPT"){
   flag=false
 }
})
if(flag==true )
{
  
  updateStatus(workflowtemp, res1 => {
    if(res1.status=="fail")
    {
      warning(res1.reasonText, successNotification);
    }
    else{
    success("KYD/ARN accepted Successfully.", successNotification);
    //sneha
    RegisterUserService.sendKYDMail(this.state.mailDataKYD, res2 => {
      success("KYD/ARN accepted Successfully mail sent.", successNotification);
          window.location.reload();
                          
      this.setState({ acceptDataUpload: [] })
    })

    RegisterUserService.sendSms(this.state.smsData, res3 => {
      //success("Feat completed successfully.", successNotification);
      // if(res3.status === "success"){
      //     success("KYD/ARN accepted Successfully sms sent", successNotification);
      // } else {
      //     error("KYD/ARN accepted Successfully sms failed .", errorNotification);
      // }
  })
    setTimeout(() => {
      window.location.reload();
                      }, 5000)

                     // Sneha change commit 
   // RegisterUserService.sendMail(this.state.mailData, res2 => {
    //     this.setState({ mailData: [] })
    //          this.setState({ data: [] })
    //     // if (res.reasonText == "success") {
    //     //     success("Action Changed successfully.", successNotification);
    //     // }
    // })
  }
  })
}
else{

  warning("Action is invalid for Selected Distributors Current Stage should be KYD-ARN APPLIED ", warningNotification)
 // window.location.reload()
 

}
}else{
warning("Please select at least one record.", warningNotification)
}

}

// auditTrail=()=>{

//    let data1=[]
//    this.state.data.map(e=>{
//   let d1=
//     {
//        "learnerID":e.workflowId,
//     }
//     data1.push(d1)
//   })
//   console.log("smehghj madam",data1)
  
//   auditTrail(data1, (res) => {
//     let temp = []
//     // for (let i = 0; i < res.responseListObject?.length; i++) {

//     //   let obj = {}
//     //   obj["notifyTemplateName"] = res.responseListObject[i].notifyTemplateId
//     //   obj["notifyTemplateBody"] = res.responseListObject[i].notifyTemplateXml
//     //   obj["notifyTemplateSubject"] = res.responseListObject[i].notifyTemplateName
//     //   temp.push(obj)
//     // }


//     this.setState({
//       auditData: res.responseListObject,
//     })

//     let modifiedData = [];
//     let data = this.state.auditData
//     if (data?.length > 0) {


//       data.forEach((element, index) => {
//         let d = element
//         var data1 = {

//           "From ID": element.fromEmailId,
//           "From Name":"Register",
//           "Subject": element.emailSubjectText,
//           "Created date": (element.deliveryStatus || '').toString() === 'completed' ? 'Success' : 'Failure',
//           "lastmodified Date": element.toEmailIdOrMobileNo[0].action
//         };
//         modifiedData.push(data1);
//       });

//       ExcelService.ExcelData(modifiedData, 'AuditTrail');
//     }
//     else {
//       warning("No record found", warningNotification)
//     }

//   })
// }



EmpanelledWorkflowUpdate= () =>{
   
  this.setState({
    isAllow:false
  })

if(this.state.data?.length>0)
{
let flag=true
let workflowtemp={
"ExcecutionTracker":this.state.data
}
//console.log("OOOOOOOOOOOOOOOOOOOOOOOOOOOOO madam",this.state.data)

// let d1=[{
//   "flag":2,
// "txnUserId": localStorage.getItem('userid'),
// "learnerIds": [],
// "isTermsAccepted": 1,
// "isApprovedByAamc": 1,
// "partyid": localStorage.getItem("userid-Token")

// }]
let data1=[]
this.state.data.map(e=>{
if(e.action==="EMPANEL" || e.action==="EMPANELLED" ){
  let d1=
{
  "learnerID":e.workflowId,
  "mstAmcId":localStorage.getItem('amcId')
}

 data1.push(d1)
 

}else{
  flag=false
}
})
//console.log(d1)
if(flag==true )
{
if(localStorage.getItem('amcId')==="0" || localStorage.getItem('amcId')==null){
  warning("Please Select AMC from AMC LIST Dropdown", warningNotification)

}
else{
sendAmcList(data1, res1 => {
  if(res1.status=="fail")
  {
    warning(res1.reasonText, successNotification);
  }
  else{
  success("Successfully emapnelled with AMC", successNotification);
  setTimeout(() => {
  window.location.reload()},3000)

 
  RegisterUserService.sendMail(this.state.mailDataAmc, res2 => {
      this.setState({ mailData: [] })
           this.setState({ data: [] })
      // if (res.reasonText == "success") {
      //     success("Action Changed successfully.", successNotification);
      // }
  })

  RegisterUserService.sendSms(this.state.smsEmpanelmentData, res3 => {
    //success("Feat completed successfully.", successNotification);
    // if(res3.status === "success"){
    //     success("smsEmpanelmentData Successfully sms sent", successNotification);
    // } else {
    //     error("smsEmpanelmentData Successfully sms failed .", errorNotification);
    // }
})
}
})
}
}
else{

warning("Action is invalid for Selected Distributors Current Stage should be Under EMPANELED or EMPANELED ", warningNotification)
// window.location.reload()


}
}else{
warning("Please select at least one record.", warningNotification)
}











}
  exportToCSV = () => {
    let modifiedData = [];
    let data = this.props.distributorProfileUser;
    let cityName=''
    let lookingFor=''
    if (data !== null) {
    data.forEach((element,index) => { 
    //  if(element.address?.length>0)
    //   {     
    //   for (let i = 0; i < this.state.allCityList?.length; i++) {
    //     if (this.state.allCityList[i].cityId === element.address[0].cityId) {
    //       cityName= this.state.allCityList[i].cityName
    //     }

    //   }
    // }
      for (let i = 0; i < this.state.lookingForList?.length; i++) {
        if (this.state.lookingForList[i].codeValueId === Number(element.lookingFor)) {
          lookingFor= this.state.lookingForList[i].codeValue
        }
      }

      let cityDetails = element.address[0].cityId? element.address[0].cityId:"";
        let cityName = this.getCity(cityDetails) 


      var data1 = {
        "Sr. No.":index+1,
        "First Name": element.firstName,
        "Last Name": element.lastName,
        "Email ID": element.emailID,
        "Mobile No": element.mobileNo,
        "PAN No": element.panNumber,
        "Is Amfi User": element.isAmfiUser===0?"No":'Yes',
        "Candidate Type": lookingFor,
        "Location":this.titleCase(cityName),
        "Registration Date":moment( element.createdDate,"DD/MM/YYYY hh:mm:ss").format("DD-MM-YYYY"),
        "Who You Are": element.learnerType===1011?"Student":element.learnerType===1012?"Entrepreneur":element.learnerType===1013?"Professional":element.learnerType===1014?"Home Maker":element.learnerType===1015?"Retired":'',
        "College Name": element.collegeName!==undefined? element.collegeName:"-",
        "FINX Internship":element.isFinXInternship===1?"Yes":element.isFinXInternship===0?"No":"Not Applicable",
        "Completed Stage": element.learnerWorkflowMap[0]? element.learnerWorkflowMap[0].status.toUpperCase():'',
        "Profile Status":element.applicationStatus,
       // "NISM Score":"NA"
      };
      modifiedData.push(data1);
    });
    let date = new Date();
    let time = new Date().toLocaleString().split(",")[1]

    let time1 = time.split(" ")[2]
    let time2 = time.split(":")[0] + "-" + time.split(":")[1] + "-" + time1
    ///  alert(time)
    time2 = time2.split(" ")[1]

    let date1 = moment(date).format("DD-MM-YYYY")
  
   let title1="Distributor-List-"+ time2 
  //  let title1="Distributor-List-"+date1
    ExcelService.ExcelData(modifiedData, title1);
  }
  else {
    warning("No record found", warningNotification)
  }
  };

  exportToAMCCSV = () => {
    let modifiedData = [];
    let data = this.props.distributorProfileUser;
    if (data !== null) {
    let cityName=''
    let lookingFor=''
    data.forEach((element,index) => {
      if(element.address?.length>0)
      {
      for (let i = 0; i < this.state.allCityList?.length; i++) {
        if (this.state.allCityList[i].cityId === element.address[0].cityId) {
          cityName= this.state.allCityList[i].cityName
        }
      }
    }
      for (let i = 0; i < this.state.lookingForList?.length; i++) {
        if (this.state.lookingForList[i].codeValueId === Number(element.lookingFor)) {
         lookingFor= this.state.lookingForList[i].codeValue
        }
      }
      let nextStage=""
      if(element.learnerWorkflowMap[0])
      {
      for(let i=0;i<this.state.nextStage?.length;i++)
      {
        if(element.learnerWorkflowMap[0].status.toUpperCase()==this.state.nextStage[i].currentState)
        nextStage=this.state.nextStage[i].nextState.toUpperCase()
      }
    }
    else{
      nextStage=""
    }
      var data1 = {
        "Sr. No.":index+1,
        "Registration Date":moment(element.createdDate.split(" ")[0],"DD/MM/YYYY").format("DD-MM-YYYY"),

       
        "Completed Stage":element.learnerWorkflowMap[0]? element.learnerWorkflowMap[0].status.toUpperCase():'',
        "First Name": element.firstName,
        "Last Name": element.lastName,
        "PAN Number": element.panNumber,
        "Next Stage":nextStage,
       
        "Profile Status":element.applicationStatus
      };
      modifiedData.push(data1);
    });

    let date = new Date();
    let time = new Date().toLocaleString().split(",")[1]

    let time1 = time.split(" ")[2]
    let time2 = time.split(":")[0] + "-" + time.split(":")[1] + "-" + time1
    ///  alert(time)
    time2 = time2.split(" ")[1]

    let date1 = moment(date).format("DD-MM-YYYY")
    // let d2 = date1

    //    let title = "Feat-List-" + time2 + "-"
   // let title1 = "ExpertMFD-DateRequest-List-" + date1 + "-" + time2 + ".pdf"
//let title1="Distributor-List-"+ date1 + "-" + time2 + ".pdf"
   let title1="Distributor-List-"+ time2 
    // let date=new Date();
    // let title1="ExpertMFD-DistributorList-"+date
   // doc.save(title)
    ExcelService.ExcelData(modifiedData, title1);
  }
  else {
    warning("No record found", warningNotification)
  }
  };

  exportPDF = () => {
    if ( this.props.distributorProfileUser !== null) {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    let modifiedData = [];
    const title = "Distributor List";
    const headers = [["Sr No.","First Name", "Last Name","Email ID","Mobile No","PAN No","Is Amfi User","Candidate Type","Location", "Registration Date","Who You Are","Completed Stage","Profile Status"]];
    this.props.distributorProfileUser.forEach((element,index) => {
     // console.log(this.state.allCityList[0].cityId)
      let cityName=''
      let lookingFor=''
            for (let i = 0; i < this.state.allCityList?.length; i++) {
              if(element.address?.length>0)
              {
              if (this.state.allCityList[i].cityId === element.address[0].cityId) {
                cityName= this.state.allCityList[i].cityName
              }    
            }  
            }
            for (let i = 0; i < this.state.lookingForList?.length; i++) {
              if (this.state.lookingForList[i].codeValueId === Number(element.lookingFor)) {
                lookingFor= this.state.lookingForList[i].codeValue
              }      
            }
         modifiedData.push( [
           index+1,
            element.firstName,
            element.lastName,
            element.emailID,
            element.mobileNo,
            element.panNumber,
            element.isAmfiUser===0?"No":'Yes',
            lookingFor,
            this.titleCase(cityName),
           moment( element.createdDate,"DD/MM/YYYY hh:mm:ss").format("DD-MM-YYYY"),
           element.learnerType===1011?"Student":element.learnerType===1012?"Entrepreneur":element.learnerType===1013?"Professional":element.learnerType===1014?"Home Maker":element.learnerType===1015?"Retired":'',

            element.learnerWorkflowMap[0]? element.learnerWorkflowMap[0].status.toUpperCase():'',
          element.applicationStatus,
         
            ])
           
          });
   
    let content = {
      startY: 50,
      head: headers,
      body: modifiedData
    };
   // doc.setFontSize(8);
    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
  //  doc.text(title, marginLeft, 40);
          //  doc.autoTable(content);
            let date = new Date();
            let time = new Date().toLocaleString().split(",")[1]

            let time1 = time.split(" ")[2]
            let time2 = time.split(":")[0] + "-" + time.split(":")[1] + "-" + time1
            ///  alert(time)
            time2 = time2.split(" ")[1]

            let date1 = moment(date).format("DD-MM-YYYY")
            // let d2 = date1

            //    let title = "Feat-List-" + time2 + "-"
           // let title1 = "ExpertMFD-DateRequest-List-" + date1 + "-" + time2 + ".pdf"
   let title1="Distributor-List-"+ date1 + "-" + time2 + ".pdf"
    doc.save(title1)
  //  if(data1?.length==i1+1){
     

   // }
  }
  else {
    warning("No record found", warningNotification)
  }
  }

  exportAMCPDF = () => {
    if ( this.props.distributorProfileUser !== null) {

    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    let modifiedData = [];
    const title = "Distributor List";
    const headers = [[ "Sr. No.","Registration Date","Completed Stage","First Name", "Last Name","PAN No","Next Stage","Profile Status"]];
    let nextStage=""
    this.props.distributorProfileUser.forEach((element,index) => {  
     if(element.learnerWorkflowMap[0])
     {
      for(let i=0;i<this.state.nextStage?.length;i++)
      {
        if(element.learnerWorkflowMap[0].status.toUpperCase()==this.state.nextStage[i].currentState)
        nextStage=this.state.nextStage[i].nextState.toUpperCase()
      }
    }
    else{
      nextStage=""
    }
        
          

       console.log(nextStage)
      let cityName=''
      let lookingFor=''           
         modifiedData.push( [
         index+1,
         moment(element.createdDate.split(" ")[0],"DD/MM/YYYY").format("DD-MM-YYYY"),
         
        element.learnerWorkflowMap[0]? element.learnerWorkflowMap[0].status.toUpperCase():'',
               element.firstName,
              element.lastName,
            
               element.panNumber,
            
               nextStage,
            element.applicationStatus
            ])
           
          });
   
    let content = {
      startY: 50,
      head: headers,
      body: modifiedData
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
   // doc.save("distributorList.pdf")
   let date = new Date();
   let time = new Date().toLocaleString().split(",")[1]

   let time1 = time.split(" ")[2]
   let time2 = time.split(":")[0] + "-" + time.split(":")[1] + "-" + time1
   ///  alert(time)
   time2 = time2.split(" ")[1]

   let date1 = moment(date).format("DD-MM-YYYY")
   // let d2 = date1

   //    let title = "Feat-List-" + time2 + "-"
  // let title1 = "ExpertMFD-DateRequest-List-" + date1 + "-" + time2 + ".pdf"
let title1="Distributor-List-"+ date1 + "-" + time2 + ".pdf"
    doc.save(title1)
  }
  else {
    warning("No record found", warningNotification)
  }
  }
 

  getCity=(data)=>{
    let cityName=''
    for (let i = 0; i < this.state.allCityList?.length; i++) {
      if (this.state.allCityList[i].cityId === Number(data)) {
        cityName=  cityName + this.state.allCityList[i].cityName
      }
    }
    return cityName;
  }


  getState=(data)=>{
    let StateName=''
    for (let i = 0; i < this.state.stateListForPer?.length; i++) {
      if (this.state.stateListForPer[i].stateId === Number(data)) {
        StateName=  StateName + this.state.stateListForPer[i].stateName
      }
    }
    return StateName
  }

  getDataUrl = (url) => {
      var img = new Image();

      img.onError = function() {
          alert('Cannot load image: "'+url+'"');
  };
      // img.onload = function() {
      //     callback(img);
      // };
      img.src = url;
      return img;

    //   // Create canvas
    //   const canvas = document.createElement('canvas');
    //   const ctx = canvas.getContext('2d');
    //   // Set width and height
    //   canvas.width = img.width;
    //   canvas.height = img.height;
    //   const img1 = new Image();
    //   img1.onload = function(){
    //     ctx.drawImage(img, 0, 0);

    //     alert(canvas.toDataURL('image/jpeg'));
    // };
    //   // Draw the image
    //   ctx.drawImage(img, 0, 0);
    //   return canvas.toDataURL('image/jpeg');
  }

  geIncomeDetails = (data)=> {
    let annualIncome='';
    for (let i = 0; i < this.state.AuualIncomeList?.length; i++) {
      if (this.state.AuualIncomeList[i].codeValueId === Number(data)) {
        annualIncome=  annualIncome + this.state.AuualIncomeList[i].codeValue;
      }
    }
    return annualIncome;
  };

  getOccupation=(data)=>{
    
    let occupation=''
    
    // if(data.learnerProfessionalQualification?.length>0)
    // {}
      // for(let i=0;i<data.learnerProfessionalQualification?.length;i++)
      // {
    for (let i = 0; i < this.state.occupation?.length; i++) {


      if (this.state.occupation[i].codeValueId === Number(data)) {


        occupation=  occupation + this.state.occupation[i].codeValue
      
      }

    // }
    }
    return occupation
  }

  handleBlock = (event, values) => {
      this.setState({ loading: true });
      //setTimeout(() => {
      let data = {
        userId: values.userId,
        loginAttempt: values.loginAttempt === 3 ? 0 : 3,
      };
      LoginService.TokenUser(res => {
        if (res.status === "success") {
          localStorage.setItem("jwt-token", res.responseObject);
          unblockUser(data, cb => {
            if (cb.status === "success") {
              success("Status changed successfully", successNotification);
              this.props.fetchAdminUser('limit=-1');
              this.setState({ loading: false });
            }
          });
        }
      })
  }

  handleStatus = (event, values) => {
    setTimeout(() => {
      this.setState({ loading: true });
      LoginService.TokenUser(res => {
        if (res.status === "success") {
          localStorage.setItem("jwt-token", res.responseObject);
          this.setState({ selectionuser: [] });
          let data = {
            roleID: values.userRoleMatrixList[0].roleId.roleId,
            partyID: values.partyID,
            userID: values.userId,
            isActive: values.isActive === 1 ? 0 : 1
          };

          this.state.selectionuser.push(data)

          ProductService.bulkupdateuserstatus(this.state.selectionuser, res => {

            if (res.status === "success") {
              success("User Status Updated successfully", successNotification);
              this.props.fetchAdminUser('limit=-1');
              this.setState({ loading: false });
            }
            else {
              error(res.reasonText, errorNotification);
            }
          });

        }
      });
    }, 1000);
  }

  sendEmail = (values) => {
    this.setState({
      dat: values.name,
      dat2: values.emailId,
      stud: values.partyID
    })
    // //console.log("values",this.state.dat)
  }

  handleaddCourse = (props) => {

  
    if (props.isActive === 0) {
      warning("You cannot assign the courses to learner, who are In-Active. Please activate the learner first then Assign the course", warningNotification);
    } else {
      if (props.loginAttempt < 3) {
        this.props.history.push("/add-learner-course", { role: props })
      }
      else {
        warning("User Account is blocked. You cannot Edit the profile", warningNotification);
      }
    }

  }
  handleChangePassword = (props) => {
    this.props.history.push("/changePassword", {
      userId: props.userId,
      userLoginName: props.userLoginName,
      emailId: props.emailId,
      fromAdminChangePassword: true
    })
  }


  userbulk = () => {

    // this.props.history.push("/userbulkupload")
    this.props.history.push("/userbulkupload",
      {
        alerts: this.props.alertNotificationEvents,
        notification: this.props.notificationEvents,
      })
  }
//redirectToUserProfile
redirectToUserProfile = (e,data) => {

localStorage.setItem("userid-Token",data.learnerPartyID)
    this.props.history.push("/userprofile"
    , 
    
    
    ) 
  }

  // Check All User Handler
  checkAlluserHandler = () => {

    var self = this
    //alert('clicked'+ self.state.selectAll)

    this.setState({
      selectAlluser: self.state.selectAlluser == true ? false : true,
    })

    //$("input:checkbox").prop("checked", self.state.selectAll);




  }

  // Check Single Handler
  handleCheck = (props) => {

    //console.log("Checkbox props  : ", props)
    //alert('select single'+ JSON.stringify(props));
    //console.log("chcked")
  }
  onChangeParameter (selected, setFieldValue) {
    setFieldValue('city', selected)
  //  this.props.getDevices(selected.value)
  }  

  bulkupdateuserstatus = (e) => {
    if (this.state.selectAlluser == false) {
    }
    let ActiveInActiveValue = 1;
    if (e.currentTarget.name === 'InActive') {
      ActiveInActiveValue = 0;
    }
    var userstatus = ActiveInActiveValue
    this.setState({ selectionuser: [] });
    var checkeduserdata = [];
    $.each($("input[type='checkbox']:checked"), function () {
      if ($(this).val() !== 'on' && $(this).val() !== 'NaN') {
        checkeduserdata.push(parseInt($(this).val()))
      }
    });

    if (checkeduserdata?.length > 0) {
      
      this.props.adminUser.map(person => {
        if (checkeduserdata.includes(person.userId)) {
          var usersdata = {};
          Object.assign(usersdata, { roleID: person.userRoleMatrixList[0].roleId.roleId });
          Object.assign(usersdata, { userID: person.userId });
          Object.assign(usersdata, { partyID: person.partyID });
          Object.assign(usersdata, { isActive: userstatus });
          this.setState({ selectionuser: this.state.selectionuser.push(usersdata), })
        }
      })

      ProductService.bulkupdateuserstatus(this.state.selectionuser, res => {
        if (res.status === "success") {
          success("User Status Updated successfully", successNotification);
          this.props.fetchAdminUser('limit=-1');
        }
        else {
          error(res.reasonText, errorNotification);
          this.props.fetchAdminUser('limit=-1');
        }
      });
    }
  }

  render() {

    
    var roledata = this.props.userRoleAccess;
 
    return (
      <React.Fragment>
        {/* < 
          //alertNotificationEvents={this.props.location.state.alerts} {...this.props}
          //notificationEvents={this.props.location.state.notification}{...this.props}
          {...this.props}
        /> */}
        <PopUpPortal
          HidePopup={this.state.loading}
          IsVisible={this.state.loading}
        />
        
        
           <section className="learner-dashboard mb-50" id="learner-dashboard">
          <div class="padding-rl-50">
            <div class="container-fluid">
            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mt-50 mb-10">
                            <div className="row">
                            {/* {this.props.statusCountList} */}
                            <Funnel data={this.props.statusCountList||[]} />                                 
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                        <h3 className="learner-title">Report Table View</h3>

                    <div id="distributor-list-box">

              <h2>Filter By</h2>
                 {
                 localStorage.getItem("roleId")==6? 
                 ( 
                 <Formik
                enableReinitialize={true}
                initialValues={{
                  status: '',
                  fname: '',
                  lname: '',
                  fromDate: "",
                  toDate:"",
                  fromDate1: '',
                  toDate1: '',
                  emailId: '',
                  panNo: '',
                  cityId: '',
                  city:'',
                  parameter:'',
                   listOfMonth:this.state.listOfMonth,
                   listOfDay:this.state.listOfDay,
                   listOfMonth1:this.state.listOfMonth,
                   listOfDay1:this.state.listOfDay,
                   day:'',
                   month:'',
                   year:'',
                   today:'',
                   tomonth:'',
                   toyear:''
                }}
                validationSchema={Yup.object().shape({
                  //static validations
                  fname: Yup.string()
                    .matches(/^[a-zA-Z ]{1,180}$/, "you must specify text"),
                  emailId: Yup.string()
                    .email('Invalid E-Mail'),
                  lname: Yup.string()
                    .matches(/^[a-zA-Z ]{1,180}$/, "you must specify text"),
                  panNo: Yup.string()
                    .matches(
                      /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                      "Please enter the valid PAN number"
                    ),
                }
                )}

                onSubmit={(fields, { resetForm }) => {
                  
                  let fromDate1=""
                  if ((fields['year'] !== undefined && fields['year'] !== "") || (fields['month'] !== undefined && fields['month'] !== "") || (fields['day'] !== undefined && fields['day'] !== "")) {
                    fromDate1=fields['year'] + "-" + fields['month'] + "-" + fields['day'] 

 }else{
  //warning("Please select valid from date", warningNotification);

    fromDate1=""
   
 }

 let toDate1=""
 if ((fields['toyear'] !== undefined && fields['toyear'] !== "") || (fields['tomonth'] !== undefined && fields['tomonth'] !== "") || (fields['today'] !== undefined && fields['today'] !== "")) {
  toDate1=fields['toyear'] + "-" + fields['tomonth'] + "-" + fields['today'] 

                  }else{
                    //warning("Please select valid to date", warningNotification);

                    toDate1=""
                    
                  } 
if(fromDate1!=="" && toDate1!==""){
  if(new Date(fromDate1)>new Date(toDate1)){
    warning("To Date should be greater than From Date",warningNotification)
    fromDate1=""
    toDate1=""
  }
}
// else {
//   warning("Please select valid Date", warningNotification);

// }
                  if (fields.status == "DISTRIBUTOR_LIST") {
                    
                    // document.getElementById("ALL_DISTRIBUTOR").style.visibility = "hidden";
                    document.getElementById("ALL_DISTRIBUTOR").disabled = true;

                    this.props.fetchDistributor("firstName=&lastName=&fromDate=&toDate=&emailId=&panNumber=&cityId=0&roleId=" + localStorage.getItem("roleId") + "&applicationStatus=&stage=&additionalDetail=false&examLocation=&examFromDate=&examToDate=&stateId=&learnerId=0&amcId=0");
                  }
                  // else if (fields.status == "DISTRIBUTOR_LIST_BATCH") {
                  //   debugger;
                  //   // document.getElementById("ALL_DISTRIBUTOR").style.visibility = "hidden";
                  //   document.getElementById("ALL_DISTRIBUTOR").disabled = true;

                  //   this.props.fetchBatchDistributor("firstName=&lastName=&fromDate=&toDate=&emailId=&panNumber=&cityId=0&roleId=" + localStorage.getItem("roleId") + "&applicationStatus=&stage=&additionalDetail=false&examLocation=&examFromDate=&examToDate=&stateId=&learnerId=0&amcId=0");
                  // }
                  else if (fields.status == "SEARCH") {
                    let param = ''
                    let isblank = false;
                    if ((fields.fname !== undefined || fields.fname !== '')) {
                      param = param + "firstName=" + fields.fname + '&'
                    }
                    if ((fields.lname !== undefined || fields.lname !== '')) {
                      param = param + "lastName=" + fields.lname + '&'
                    }
                    // if (fields.fromDate1 !== undefined && fields.fromDate1 !== '') {
                    //   param = param + "fromDate=" + fields.fromDate1 + '&'
                    // }

                    if (fromDate1 !== undefined && fromDate1 !== "") {
                      param = param + "fromDate=" + fromDate1 + '&'
                    }
                    else {

                      param = param + "fromDate=" + '&'
                    }
                    if (toDate1 !== undefined && toDate1 !== "") {
                      param = param + "toDate=" + toDate1 + '&'
                    }
                    else {

                      param = param + "toDate=" + '&'
                    }
                    if ((fields.emailId !== undefined || fields.emailId !== '')) {
                      param = param + "emailId=" + fields.emailId + '&'
                    }
                    if ((fields.panNo !== undefined || fields.panNo !== '')) {
                      param = param + "panNumber=" + fields.panNo + '&'
                    }
                    if ((fields.city !== '')) {
                      param = param + "cityId=" + fields.city.value + '&'
                    } else {

                      param = param + "cityId=0" + '&'
                    }
                    if ((fields.stage !== '' && fields.stage !== undefined)) {
                      param = param + "stage=" + fields.stage + '&'
                      localStorage.setItem('stage', fields.stage)
                    } else {

                      param = param + "stage=" + '&'
                      localStorage.setItem('stage', "")
                    }
                    if ((fields.center !== '' && fields.center !== undefined)) {
                      param = param + "examLocation=" + fields.center + '&'
                    } else {

                      param = param + "examLocation=" + '&'
                    }
                    // if ((fields.city !== '' && fields.city !== undefined)) {
                    //     param = param + "stateId=" + fields.city + '&'
                    // } else {

                    //     param = param + "stateId=" + '&'
                    // }
                    if ((fields.requestedDate !== '' && fields.requestedDate !== undefined)) {
                      param = param + "examFromDate=" + fields.requestedDate + '&'
                    } else {

                      param = param + "examFromDate=" + '&'
                    }
                    if ((fields.examToDate !== '' && fields.examToDate !== undefined)) {
                      param = param + "examToDate=" + fields.examToDate + '&'
                    } else {

                      param = param + "examToDate=" + '&'
                    }

                    if ((fields.amcList !== '' && fields.amcList !== undefined)) {
                      param = param + "amcId=" + fields.amcList + '&'
                      localStorage.setItem('amcId', fields.amcList)
                    } else {

                      param = param + "amcId=0" + '&'
                      localStorage.setItem('amcId', 0)
                    }
                    if (localStorage.getItem('roleId')) {
                      param = param + "roleId=" + localStorage.getItem('roleId') + '&applicationStatus=&additionalDetail=false&learnerId=0'
                    }

                    if (fields.stage !== '' || fields.city !== '' || fields.fname !== '' || fields.lname !== '' || fields.panNo !== '' || fields.emailId !== '' || toDate1 !== "" || fromDate1 !== "") {
                      this.props.fetchDistributor(param);
                    } else {
                      warning("Atleast one parameter is required to fetch the data", warningNotification);
                    }

                  }
                  // else {
                  //   //this.props.fetchDistributor("firstName=&lastName=&fromDate=&toDate=&emailId=&panNumber=&cityId=0");
                  //   //   this.props.fetchDistributor("firstName=&lastName=&fromDate=&toDate=&emailId=&panNumber=&cityId=0&roleId="+localStorage.getItem("roleId")+"&applicationStatus=&stage=");
                  
                  //  // this.props.fetchDistributor("firstName=&lastName=&fromDate=&toDate=&emailId=&panNumber=&cityId=0&roleId=" + localStorage.getItem("roleId") + "&applicationStatus=&stage=&additionalDetail=false&examLocation=&examFromDate=&examToDate=&stateId=&learnerId=0&amcId=0");

                  // }

                }}

                render={({
                  errors, touched, handleSubmit, values, setFieldValue
                }) => (
                    <React.Fragment>
                      <Form onSubmit={handleSubmit} className="form-group">
                        <section class="updateGDPI">
                          <div class="modal-body">
                            <div class="row">
                              <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <div class="product-add">
                                  <div class="form-group">
                                    <div class="row">
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          First Name
                                        </label>
                                        <Field
                                          type="text"
                                          name="fname"
                                          id="fname"
                                          autoComplete="fname"
                                          className={
                                            "form-control" +
                                            (errors.fname &&
                                              touched.text
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="First Name"
                                          className="form-control"
                                        />
                                        <ErrorMessage
                                          name="fname"
                                          component="div"
                                          className="validation"
                                        />
                                      </div>
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          Last name
                        </label>
                                        <Field
                                          type="lname"
                                          name="lname"
                                          id="lname"
                                          autoComplete="lname"
                                          className={
                                            "form-control" +
                                            (errors.lname &&
                                              touched.lname
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Last Name"
                                        />
                                        <ErrorMessage
                                          name="lname"
                                          component="div"
                                          className="validation"
                                        />
                                      </div>
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          Email Id
                                        </label>
                                        <Field
                                          type="emailId"
                                          name="emailId"
                                          id="emailId"
                                          autoComplete="emailId"
                                          className={
                                            "form-control" +
                                            (errors.emailId &&
                                              touched.emailId
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Email Id"
                                        />
                                        <ErrorMessage
                                          name="emailId"
                                          component="div"
                                          className="validation"
                                        />
                                      </div>
                                      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12"></div>
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                        Registered From Date
                        </label>
                                        {/* <Field
                                          type="date"
                                          name="fromDate"
                                          id="fromDate"
                                          autoComplete="fromDate"
                                          className={
                                            "form-control" +
                                            (errors.fromDate &&
                                              touched.fromDate
                                              ? " is-invalid"
                                              : "")
                                          }

                                          onChange={(e) => {
                                           
                                            var FromDate = e.target.value

                                            var Todate = values.toDate
                                            if (Todate !== '' && FromDate !== '') {
                                              if ((Date.parse(Todate) < Date.parse(FromDate))) {

                                                //  alert();
                                                warning("Registered To date should be greater than Registered From date", warningNotification);
                                                setFieldValue(
                                                  (values.fromDate = "")
                                                )
                                                setFieldValue(
                                                  (values.toDate = "")
                                                );
                                              }
                                              else {
                                                setFieldValue(
                                                  (values.fromDate = FromDate)
                                                )
                                              }
                                            }
                                            else {
                                              setFieldValue(
                                                (values.fromDate = FromDate)
                                              )
                                            }
                                          }
                                          }
                                          placeholder="From Date"
                                        />
                                        <ErrorMessage
                                          name="fromDate"
                                          component="div"
                                          className="validation"
                                        /> */}

                                        
                                                  {/* <DatePicker selected={values.fromDate}
                                             //   maxDate={new Date()}
                                             autoComplete="off"
                                             placeholderText="dd-mm-yyyy"
                                             dateFormat="dd-MM-yyyy"
                                             maxLength="50"
                                             value={values.fromDate}
                                             onChangeRaw={event => {
                                              
                                              console.log(typeof event.target.value)
                                              let temp = event.target.value
                                              
                                              if (temp !== undefined) {
                                                if (temp.includes("/")) {
                                                  
                                                  setFieldValue(values.fromDate = "")
                                                  setFieldValue(values.errmsg="Date should be in dd-mm-yyyy format.")

                                                }
                                                else {
                                                //  setFieldValue(values.fromDate = date)
                                                  setFieldValue(values.errmsg="")

                                                }
                                              }
                                            }
                                            }
                                                onChange={date => {
                                               
                                                  setFieldValue(values.fromDate = date)
                                                  

                                                  setFieldValue(values.fromDate1 = moment(date).format("YYYY-MM-DD"))

                                                  // setFieldValue(values.dateOfBirth = date)
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.fromDate &&
                                                    touched.fromDate
                                                    ? " is-invalid"
                                                    : "")
                                                }

                                              /> */}



<div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                              <Field
                                                as="select"
                                                name="day"
                                                id="day"
                                                // onChange={handleChange}
                                              //  disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                   
                                                    
                                                    var listOfMonth = []
                                                    setFieldValue(values.day = e.target.value)
                                                    if (e.target.value == 31) {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                              
                                                      { "key": 3, "value": "Mar" },
                                              
                                                      { "key": 5, "value": "May" },
                                              
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                              
                                                      { "key": 10, "value": "Oct" },
                                              
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                              
                                              
                                                    } else if (e.target.value == 30) {
                                                      listOfMonth = [
                                              
                                                        { "key": 1, "value": "Jan" },
                                              
                                                        { "key": 3, "value": "Mar" },
                                                        { "key": 4, "value": "Apr" },
                                                        { "key": 5, "value": "May" },
                                                        { "key": 6, "value": "Jun" },
                                                        { "key": 7, "value": "Jul" },
                                                        { "key": 8, "value": "Aug" },
                                                        { "key": 9, "value": "Sep" },
                                                        { "key": 10, "value": "Oct" },
                                                        { "key": 11, "value": "Nov" },
                                                        { "key": 12, "value": "Dec" },
                                              
                                                      ];
                                              
                                              
                                                    }
                                                    else if (e.target.value == 28 || e.target.value == 29) {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                                      { "key": 2, "value": "Feb" },
                                                      { "key": 3, "value": "Mar" },
                                                      { "key": 4, "value": "Apr" },
                                                      { "key": 5, "value": "May" },
                                                      { "key": 6, "value": "Jun" },
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                                      { "key": 9, "value": "Sep" },
                                                      { "key": 10, "value": "Oct" },
                                                      { "key": 11, "value": "Nov" },
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                                    } else {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                                      { "key": 2, "value": "Feb" },
                                                      { "key": 3, "value": "Mar" },
                                                      { "key": 4, "value": "Apr" },
                                                      { "key": 5, "value": "May" },
                                                      { "key": 6, "value": "Jun" },
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                                      { "key": 9, "value": "Sep" },
                                                      { "key": 10, "value": "Oct" },
                                                      { "key": 11, "value": "Nov" },
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                              
                                                    }
                                              setFieldValue(values.listOfMonth= listOfMonth)
                                                    // this.setState({
                                                    //   listOfMonth: listOfMonth
                                                    // })
                                                  }}
                                              
                                                className={
                                                  "form-control" +
                                                  (errors.day && touched.day
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">DD</option>
                                                {(
                                                 values.listOfDay ||
                                                  []
                                                ).map(d => (
                                                  <option
                                                    value={d}
                                                  >
                                                    {d}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                              <Field
                                                as="select"
                                                name="month"
                                                id="month"
                                                //   onChange={handleChange}
                                           //     disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                    
                                          
                                                    setFieldValue(values.month = e.target.value)
                                                    if (e.target.value == 2) {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 29; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                       // this.setState({ listOfDay: listOfDay });
                                                      }
                                                    } else if (e.target.value == 1 || e.target.value == 3 || e.target.value == 5 || e.target.value == 7 || e.target.value == 8 || e.target.value == 10 || e.target.value == 12) {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 31; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                      //  this.setState({ listOfDay: listOfDay });
                                                      }
                                                    }
                                                    else {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 30; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                      //  this.setState({ listOfDay: listOfDay });
                                                      }
                                                    }
                                          
                                                    setFieldValue(values.listOfDay=listOfDay)
                                                  }
                                                }
                                                className={
                                                  "form-control" +
                                                  (errors.month && touched.month
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">MM</option>
                                                {(
                                                 values.listOfMonth ||
                                                  []
                                                ).map(m => (
                                                  <option
                                                    value={m.key}
                                                  >
                                                    {m.value}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                                as="select"
                                                name="year"
                                                id="year"
                                               // onChange={handleChange}
                                            //    disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                   
                                                  
                                                    setFieldValue(values.year = e.target.value)
                                                  }}
                                                className={
                                                  "form-control" +
                                                  (errors.year && touched.year
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.listOfYear1 ||
                                                  []
                                                ).map(year => (
                                                  <option
                                                    value={year}
                                                  >
                                                    {year}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>



                                            <p className="validation">  {values.errmsg}</p>
                                              {errors.fromDate && <div className="validation">{errors.fromDate}</div>}
                                      </div>
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                        Registered To Date
                                      </label>

                                      
<div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                              <Field
                                                as="select"
                                                name="today"
                                                id="today"
                                                // onChange={handleChange}
                                              //  disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                   
                                                    
                                                    var listOfMonth = []
                                                    setFieldValue(values.today = e.target.value)
                                                    if (e.target.value == 31) {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                              
                                                      { "key": 3, "value": "Mar" },
                                              
                                                      { "key": 5, "value": "May" },
                                              
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                              
                                                      { "key": 10, "value": "Oct" },
                                              
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                              
                                              
                                                    } else if (e.target.value == 30) {
                                                      listOfMonth = [
                                              
                                                        { "key": 1, "value": "Jan" },
                                              
                                                        { "key": 3, "value": "Mar" },
                                                        { "key": 4, "value": "Apr" },
                                                        { "key": 5, "value": "May" },
                                                        { "key": 6, "value": "Jun" },
                                                        { "key": 7, "value": "Jul" },
                                                        { "key": 8, "value": "Aug" },
                                                        { "key": 9, "value": "Sep" },
                                                        { "key": 10, "value": "Oct" },
                                                        { "key": 11, "value": "Nov" },
                                                        { "key": 12, "value": "Dec" },
                                              
                                                      ];
                                              
                                              
                                                    }
                                                    else if (e.target.value == 28 || e.target.value == 29) {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                                      { "key": 2, "value": "Feb" },
                                                      { "key": 3, "value": "Mar" },
                                                      { "key": 4, "value": "Apr" },
                                                      { "key": 5, "value": "May" },
                                                      { "key": 6, "value": "Jun" },
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                                      { "key": 9, "value": "Sep" },
                                                      { "key": 10, "value": "Oct" },
                                                      { "key": 11, "value": "Nov" },
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                                    } else {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                                      { "key": 2, "value": "Feb" },
                                                      { "key": 3, "value": "Mar" },
                                                      { "key": 4, "value": "Apr" },
                                                      { "key": 5, "value": "May" },
                                                      { "key": 6, "value": "Jun" },
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                                      { "key": 9, "value": "Sep" },
                                                      { "key": 10, "value": "Oct" },
                                                      { "key": 11, "value": "Nov" },
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                              
                                                    }
                                              setFieldValue(values.listOfMonth1= listOfMonth)
                                                    // this.setState({
                                                    //   listOfMonth: listOfMonth
                                                    // })
                                                  }}
                                              
                                                className={
                                                  "form-control" +
                                                  (errors.today && touched.today
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">DD</option>
                                                {(
                                                  values.listOfDay1 ||
                                                  []
                                                ).map(d => (
                                                  <option
                                                    value={d}
                                                  >
                                                    {d}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                              <Field
                                                as="select"
                                                name="tomonth"
                                                id="tomonth"
                                                //   onChange={handleChange}
                                           //     disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                    

                                                    setFieldValue(values.tomonth = e.target.value)
                                                    if (e.target.value == 2) {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 29; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                       // this.setState({ listOfDay: listOfDay });
                                                      }
                                                    } else if (e.target.value == 1 || e.target.value == 3 || e.target.value == 5 || e.target.value == 7 || e.target.value == 8 || e.target.value == 10 || e.target.value == 12) {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 31; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                      //  this.setState({ listOfDay: listOfDay });
                                                      }
                                                    }
                                                    else {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 30; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                      //  this.setState({ listOfDay: listOfDay });
                                                      }
                                                    }
                                                    setFieldValue(values.listOfDay1=listOfDay)
                                                  }
                                                }
                                                className={
                                                  "form-control" +
                                                  (errors.tomonth && touched.tomonth
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">MM</option>
                                                {(
                                                  values.listOfMonth1 ||
                                                  []
                                                ).map(m => (
                                                  <option
                                                    value={m.key}
                                                  >
                                                    {m.value}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                                as="select"
                                                name="toyear"
                                                id="toyear"
                                               // onChange={handleChange}
                                            //    disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                   
                                                  
                                                    setFieldValue(values.toyear = e.target.value)
                                                  }}
                                                className={
                                                  "form-control" +
                                                  (errors.toyear && touched.toyear
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.listOfYear1 ||
                                                  []
                                                ).map(year => (
                                                  <option
                                                    value={year}
                                                  >
                                                    {year}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>
                                      {/* <DatePicker selected={values.toDate}
                                        autoComplete="off"
                                        placeholderText="dd-mm-yyyy"
                                        dateFormat="dd-MM-yyyy"
                                        value={values.toDate}
                                        onChangeRaw={event => {
                                         
                                         console.log(typeof event.target.value)
                                         let temp = event.target.value
                                         
                                         if (temp !== undefined) {
                                           if (temp.includes("/")) {
                                             
                                             setFieldValue(values.toDate = "")
                                             setFieldValue(values.errmsg="Date should be in dd-mm-yyyy format.")

                                           }
                                           else {
                                             //setFieldValue(values.toDate = date)
                                             setFieldValue(values.errmsg1="")

                                           }
                                         }
                                       }
                                       }
                                        maxLength="50"
                                                minDate={values.fromDate}
                                                onChange={date => {
                                               
                                                  setFieldValue(values.toDate = date)
                                                  

                                                  setFieldValue(values.toDate1 = moment(date).format("YYYY-MM-DD"))

                                                  // setFieldValue(values.dateOfBirth = date)
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.toDate &&
                                                    touched.toDate
                                                    ? " is-invalid"
                                                    : "")
                                                }

                                              /> */}
                                         <p className="validation">  {values.errmsg1}</p>

                                              {errors.toDate && <div className="validation">{errors.toDate}</div>}
                                        {/* <Field
                                          type="date"
                                          name="toDate"
                                          id="toDate"
                                          autoComplete="toDate"
                                          className={
                                            "form-control" +
                                            (errors.toDate &&
                                              touched.toDate
                                              ? " is-invalid"
                                              : "")
                                          }
                                          onChange={(e) => {

                                            var Todate = e.target.value

                                            var FromDate = values.fromDate
                                            if (Todate !== '' && FromDate !== '') {
                                              if ((Date.parse(Todate) < Date.parse(FromDate))) {
                                                //  alert();
                                                warning("Registered To date should be greater than Registered From date", warningNotification);
                                                setFieldValue(
                                                  (values.fromDate = "")
                                                )
                                                setFieldValue(
                                                  (values.toDate = "")
                                                );
                                              }
                                              else {
                                                setFieldValue(
                                                  (values.toDate = Todate)
                                                )
                                              }
                                            }
                                            else {
                                              setFieldValue(
                                                (values.toDate = Todate)
                                              )
                                            }
                                          }
                                          }
                                          placeholder="To Date"
                                        />
                                        <ErrorMessage
                                          name="toDate"
                                          component="div"
                                          className="validation"
                                        /> */}
                                      </div>
                                    
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          Pan No
                        </label>
                                        <Field
                                          type="text"
                                          name="panNo"
                                          id="panNo"
                                          autoComplete="panNo"
                                          className={
                                            "form-control" +
                                            (errors.panNo &&
                                              touched.panNo
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="PAN No"
                                        />
                                        <ErrorMessage
                                          name="panNo"
                                          component="div"
                                          className="validation"
                                        />
                                      </div>
                                      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12"></div>
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          Location
                        </label>
                   

          <Select
           //   onBlur={() => setFieldTouched("parameter", true)}
          
              onChange={(value) => this.onChangeParameter(value, setFieldValue)}
              name="city"
              options={this.state.cityList}
              filterOption={createFilter({
                matchFrom: 'start'
                })}
              value={values.city}
            
            />

                                      </div>

                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                        Completed Stages
                        </label>
                   

          {/* <Select
           //   onBlur={() => setFieldTouched("parameter", true)}
            //  onChange={(value) => this.onChangeParameter(value, setFieldValue)}
              name="stages"
              options={this.state.Stage}
              filterOption={createFilter({
                matchFrom: 'start'
                })}
             // value={values.city}
            /> */}


<Field
                                               as="select"
                                              name="stage"
                                              id="stage"
                                              autoComplete="Quartlet"
                                              // onChange={e=>{
                                              //   setFieldValue(values.stage=e.target.value)
                                              //   localStorage.setItem('stage',e.target.value)
                                              // }}
                                              className={
                                                "form-control" +
                                                (errors.Quartlet &&
                                                  touched.Quartlet
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder="Quartlet"
                                            >
                                            <option value="">--Select--</option>
                                          
                                            <option value="REGISTERED">REGISTERED</option>
                                            <option value="PROFILE COMPLETED">PROFILE COMPLETED</option>
                                            <option value="FEAT COMPLETED">FEAT COMPLETED</option>
                                            <option value="NISM VA SUBSCRIBED">NISM VA SUBSCRIBED</option>
                                           

                                            <option value="NISM VA PAYMENT COMPLETED">NISM VA PAYMENT COMPLETED</option>
                                            <option value="NISM PROFILE CREATED">NISM PROFILES CREATED</option>
                                            <option value="NISM EXAM DATE CONFIRMED">NISM EXAM DATE CONFIRMED</option>
                                            <option value="ADMIT CARD AVAILABLE">ADMIT CARD AVAILABLE</option>
                                            <option value="NISM VA CERTIFICATION">NISM VA CERTIFICATION</option>
                                            <option value="KYD-ARN APPLIED">KYD-ARN APPLIED</option>
                                           
                                            <option value="KYD-ARN ACCEPTED">KYD-ARN ACCEPTED</option>
                                            <option value="UNDER EMPANELMENT">UNDER EMPANELMENT</option>
                                            <option value="EMPANELLED">EMPANELLED</option>
                                           
                                           






                                                </Field>



                                
                                      </div>
                                
                                      {/* {values.stage=="UNDER EMPANELMENT" ||values.stage=="EMPANELLED"? */}
                                      <div class="col-md-4 col-sm-4 col-xs-12">
                                        <label>
                                          {/* {values.stage} */}
                                        AMC List
                        </label>
                   



<Field
                                               as="select"
                                              name="amcList"
                                              id="amcList"
                                              autoComplete="amcList"
                                              className={
                                                "form-control" +
                                                (errors.amcList &&
                                                  touched.amcList
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder="amcList"
                                             
                                              disabled={values.stage=="UNDER EMPANELMENT" ||values.stage=="EMPANELLED"?false:true}
                                            >

{/* AmcList */}
                                            <option value="">--Select--</option>
                                            {this.state.AmcList&&this.state.AmcList?.length>0 && this.state.AmcList.map(team =>
                                           
                                              <option
                                                key={team.mst_amc_id}
                                                value={team.mst_amc_id}
                                              >
                                                {team.mst_amc_name}
                                              </option>
                                            ) }





                                                </Field>



                                
                                      </div>
                                      {/* :""} */}
                                    </div>
                                  </div>
                                  <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr mb-20">
                                  <button
                                          type="submit"
                                          class="btn-4 pull-right"
                                          id="ALL_DISTRIBUTOR"
                                          onClick={async () => {
                                            setFieldValue(
                                              (values.status = "DISTRIBUTOR_LIST")
                                            );
                                          }}
                                        >
                                          All Distributors 
                                        </button>
                                   
                                    <button
                                      type="submit"
                                      class="btn-4 pull-right"
                                      onClick={async () => {



                                        setFieldValue(
                                          (values.status = 'SEARCH')
                                        );
                                      }}
                                    >Search</button>
                                    <button
                                      type="submit"
                                      id="close"
                                      class="btn-4 pull-right"
                                      onClick={async () => {
                                        setFieldValue(
                                          (values.status = 'RESET')
                                        );

                                        setFieldValue(
                                          (values.fname = '')
                                        );
                                        setFieldValue(
                                          (values.lname = '')
                                        );
                                        setFieldValue(
                                          (values.fromDate = '')
                                        ); setFieldValue(
                                          (values.toDate = '')
                                        );
                                        setFieldValue(
                                          (values.emailId = '')
                                        ); setFieldValue(
                                          (values.panNo = '')
                                        );

                                        setFieldValue(
                                          (values.city = '')
                                        );
                                        setFieldValue(
                                          (values.stage = '')
                                        );
                                        setFieldValue(
                                          (values.amcList = '')
                                        );



                                        setFieldValue(
                                          (values.day = "")
                                        );
                                        setFieldValue(
                                          (values.month = "")
                                        );
                                        setFieldValue(
                                          (values.year = "")
                                        );


                                        setFieldValue(
                                          (values.today = "")
                                        );
                                        setFieldValue(
                                          (values.tomonth = "")
                                        );
                                        setFieldValue(
                                          (values.toyear = "")
                                        );

                                        
                                        localStorage.setItem('stage',"")
                                        //localStorage.setItem('amcid',"")
                                      }}
                                    >
                                      Reset
                  </button>
                                      <button
                                          type="submit"
                                          class="btn-4 pull-right"
                                          id="BATCH_REPORT"
                                          onClick={this.batchReport}
                                        >
                                          Batch Report
                                        </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </Form>
                    </React.Fragment>
                  )}
              /> 
              ):( 
          <Formik
                enableReinitialize={true}
                initialValues={{
                  // subject: '',
                  // emailId: '',
                  // message: '',
                  status: '',
                  fname: '',
                  lname: '',
                  fromDate:"",
                  toDate:"",
                  emailId: '',
                  panNo: '',
                  cityId: '',
                  city:'',
                  parameter:'',
                  fromDate1:'',
                  toDate1:'',
                  listOfMonth:this.state.listOfMonth,
                  listOfDay:this.state.listOfDay,
                  listOfMonth1:this.state.listOfMonth,
                  listOfDay1:this.state.listOfDay,
                  day:'',
                  month:'',
                  year:'',
                  today:'',
                  tomonth:'',
                  toyear:''
                }}
                validationSchema={Yup.object().shape({
                  //static validations
                  fname: Yup.string()
                    .matches(/^[a-zA-Z ]{1,180}$/, "you must specify text"),
                  emailId: Yup.string()
                    .email('Invalid E-Mail'),
                  lname: Yup.string()
                    .matches(/^[a-zA-Z ]{1,180}$/, "you must specify text"),
                  panNo: Yup.string()
                    .matches(
                      /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
                      "Please enter the valid PAN number"
                    ),
                }
                )}

                // onSubmit={(values, actions) => {
                //   //console.log("Submitted :" + JSON.stringify(values));
                // }}
                onSubmit={(fields, { resetForm }) => {
                
 let fromDate1=""
 if ((fields['year'] !== undefined && fields['year'] !== "") || (fields['month'] !== undefined && fields['month'] !== "") || (fields['day'] !== undefined && fields['day'] !== "")) {
  fromDate1=fields['year'] + "-" + fields['month'] + "-" + fields['day'] 

 }else{
    fromDate1=""
   
 }

 let toDate1=""
 if ((fields['toyear'] !== undefined && fields['toyear'] !== "") || (fields['tomonth'] !== undefined && fields['tomonth'] !== "") || (fields['today'] !== undefined && fields['today'] !== "")) {
  toDate1=fields['toyear'] + "-" + fields['tomonth'] + "-" + fields['today'] 

                  }else{
                    toDate1=""
                    
                  } 

                  if(fromDate1!=="" && toDate1!==""){
                    if(new Date(fromDate1)>new Date(toDate1)){
                      warning("To Date should be greater than From Date",warningNotification)
                      fromDate1=""
                      toDate1=""
                    }
                  }
                  // else {
                  // //  warning("Please select valid Date", warningNotification);

                  // }
                  if (fields.status == "SEARCH") {
                    let param = ''
                    if (fields.fname !== undefined || fields.fname !== '') {
                      param = param + "firstName=" + fields.fname + '&'
                    }
                    if (fields.lname !== undefined || fields.lname !== '') {
                      param = param + "lastName=" + fields.lname + '&'
                    }
                    if (fromDate1 !== undefined || fromDate1 !== "") {
                      param = param + "fromDate=" + fromDate1 + '&'
                    }
                    else {

                      param = param + "fromDate=" + '&'
                  }
                    if (toDate1 !== undefined || toDate1 !== '') {
                      param = param + "toDate=" + toDate1 + '&'
                    }
                    else {

                      param = param + "toDate=" + '&'
                  }
                    // if (fields.emailId !== undefined || fields.emailId !== '') {
                    //   param = param + "emailId=" + fields.emailId + '&'
                    // }
                    if (fields.panNo !== undefined || fields.panNo !== '') {
                      param = param + "panNumber=" + fields.panNo + '&'
                    }
                    if ((fields.city!== '')) {
                      param = param + "cityId="+fields.city.value+ '&'   
                    } else{
  
                      param = param + "cityId=0"+ '&'
                    }
                    if ((fields.stage!== '' &&  fields.stage!==undefined)) {
                      param = param + "stage="+fields.stage+ '&'   
                      localStorage.setItem('stage',fields.stage)

                    } else{
  
                      param = param + "stage="+ '&'
                      localStorage.setItem('stage',"")

                    }
                    if ((fields.center !== '' && fields.center !== undefined)) {
                      param = param + "examLocation=" + fields.center + '&'
                  } else {

                      param = param + "examLocation=" + '&'
                  }
                  // if ((fields.city !== '' && fields.city !== undefined)) {
                  //     param = param + "stateId=" + fields.city + '&'
                  // } else {

                  //     param = param + "stateId=" + '&'
                  // }
                  if ((fields.requestedDate !== '' && fields.requestedDate !== undefined)) {
                      param = param + "examFromDate=" + fields.requestedDate + '&'
                  } else {

                      param = param + "examFromDate=" + '&'
                  }
                  if ((fields.examToDate !== '' && fields.examToDate !== undefined)) {
                      param = param + "examToDate=" + fields.examToDate + '&'
                  } else {

                      param = param + "examToDate=" + '&'
                  }
                  if ((fields.amcList !== '' && fields.amcList !== undefined)) {
                    param = param + "amcId=" + fields.amcList + '&'
                    localStorage.setItem('amcId',fields.amcList)
                } else {

                    param = param + "amcId=0" + '&'
                    localStorage.setItem('amcId',0)
                }
                    if(localStorage.getItem('roleId'))
                    {
                      param = param + "roleId="+localStorage.getItem('roleId')+'&applicationStatus=&additionalDetail=false&learnerId=0'
                    }
                    
                    if(fields.stage !='' || fields.city !=='' || fields.fname !== '' || fields.lname !== '' || fields.panNo !== '' || fields.emailId !== '' || toDate1 !== "" || fromDate1 !=="") {
                      this.props.fetchDistributor(param);
                    }
                    
                    else {
                      warning("Atleast one parameter is required to fetch the data", warningNotification);
                    }
                    //fields.fname!==undefined?"firstName="+fields.fname+'&':''+fields.fromDate!==undefined?"fromDate="+fields.fromDate+'&':''+fields.toDate!==undefined?"toDate="+fields.toDate+'&':''+fields.emailId!==undefined?"emailId="+fields.emailId+'&':''+fields.panNo!==undefined?"panNumber="+fields.panNo:''+fields.lname!==undefined?"lastName="+fields.lname:'');
                  }

                  
                  else {


                  //  this.props.fetchDistributor("firstName=&lastName=&fromDate=&toDate=&emailId=&panNumber=&cityId=0&roleId="+localStorage.getItem("roleId")+"&applicationStatus=&stage=");
                    this.props.fetchDistributor("firstName=&lastName=&fromDate=&toDate=&emailId=&panNumber=&cityId=0&roleId=" + localStorage.getItem("roleId") + "&applicationStatus=&stage=&additionalDetail=false&examLocation=&examFromDate=&examToDate=&stateId=&learnerId=0");


                  }
                   
                }}

                render={({
                  errors, touched, handleSubmit, values, setFieldValue
                }) => (
                    <React.Fragment>
                      <Form onSubmit={handleSubmit} className="form-group">
                        <section class="updateGDPI">
                          <div class="modal-body">
                            <div class="row">
                              <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <div class="product-add">
                                  <div class="form-group">
                                    <div class="row">
                                      <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          First Name
                       
                                        </label>
                                        <Field
                                          type="text"
                                          name="fname"
                                          id="fname"
                                          autoComplete="fname"
                                          className={
                                            "form-control" +
                                            (errors.fname &&
                                              touched.text
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="First Name"
                                          className="form-control"
                                        />
                                        <ErrorMessage
                                          name="fname"
                                          component="div"
                                          className="validation"
                                        />
                                      </div>
                                      <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          Last name
                        </label>
                                        <Field
                                          type="lname"
                                          name="lname"
                                          id="lname"
                                          autoComplete="lname"
                                          className={
                                            "form-control" +
                                            (errors.lname &&
                                              touched.lname
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="Last Name"
                                        />
                                        <ErrorMessage
                                          name="lname"
                                          component="div"
                                          className="validation"
                                        />
                                      </div>
                                      
                                      <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                          Pan No
                        </label>
                                        <Field
                                          type="text"
                                          name="panNo"
                                          id="panNo"
                                          autoComplete="panNo"
                                          className={
                                            "form-control" +
                                            (errors.panNo &&
                                              touched.panNo
                                              ? " is-invalid"
                                              : "")
                                          }
                                          placeholder="PAN No"
                                        />
                                        <ErrorMessage
                                          name="panNo"
                                          component="div"
                                          className="validation"
                                        />
                                      </div>
                                      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12"></div>
                                      <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                        Registered From Date
                        </label>
                                        {/* <Field
                                          type="date"
                                          name="fromDate"
                                          id="fromDate"
                                          autoComplete="fromDate"
                                          className={
                                            "form-control" +
                                            (errors.fromDate &&
                                              touched.fromDate
                                              ? " is-invalid"
                                              : "")
                                          }

                                          onChange={(e) => {
                                           
                                            var FromDate = e.target.value

                                            var Todate = values.toDate
                                            if (Todate !== '' && FromDate !== '') {
                                              if ((Date.parse(Todate) < Date.parse(FromDate))) {

                                                //  alert();
                                                warning("Registered To date should be greater than Registered From date", warningNotification);
                                                setFieldValue(
                                                  (values.fromDate = "")
                                                )
                                                setFieldValue(
                                                  (values.toDate = "")
                                                );
                                              }
                                              else {
                                                setFieldValue(
                                                  (values.fromDate = FromDate)
                                                )
                                              }
                                            }
                                            else {
                                              setFieldValue(
                                                (values.fromDate = FromDate)
                                              )
                                            }
                                          }
                                          }
                                          placeholder="From Date"
                                        />
                                        <ErrorMessage
                                          name="fromDate"
                                          component="div"
                                          className="validation"
                                        />
                                      </div>
                                      <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                        Registered To Date
                                      </label>
                                        <Field
                                          type="date"
                                          name="toDate"
                                          id="toDate"
                                          autoComplete="toDate"
                                          className={
                                            "form-control" +
                                            (errors.toDate &&
                                              touched.toDate
                                              ? " is-invalid"
                                              : "")
                                          }
                                          onChange={(e) => {

                                            var Todate = e.target.value

                                            var FromDate = values.fromDate
                                            if (Todate !== '' && FromDate !== '') {
                                              if ((Date.parse(Todate) < Date.parse(FromDate))) {
                                                //  alert();
                                                warning("Registered To date should be greater than Registered From date", warningNotification);
                                                setFieldValue(
                                                  (values.fromDate = "")
                                                )
                                                setFieldValue(
                                                  (values.toDate = "")
                                                );
                                              }
                                              else {
                                                setFieldValue(
                                                  (values.toDate = Todate)
                                                )
                                              }
                                            }
                                            else {
                                              setFieldValue(
                                                (values.toDate = Todate)
                                              )
                                            }
                                          }
                                          }
                                          placeholder="To Date"
                                        />
                                        <ErrorMessage
                                          name="toDate"
                                          component="div"
                                          className="validation"
                                        />
                                      </div> */}
                                     
                                      {/* <DatePicker selected={values.fromDate}
                                              //  maxDate={new Date()}
                                              autoComplete="off"
                                              placeholderText="dd-mm-yyyy"
                                              dateFormat="dd-MM-yyyy"
                                              maxLength="50"
                                              value={values.fromDate}
                                              onChangeRaw={event => {
                                               
                                               console.log(typeof event.target.value)
                                               let temp = event.target.value
                                               
                                               if (temp !== undefined) {
                                                 if (temp.includes("/")) {
                                                   
                                                   setFieldValue(values.fromDate = "")
                                                   setFieldValue(values.errmsg="Date should be in dd-mm-yyyy format.")
      
                                                 }
                                                 else {
                                                //   setFieldValue(values.fromDate = date)
                                                   setFieldValue(values.errmsg="")
      
                                                 }
                                               }
                                             }
                                             }
                                                onChange={date => {
                                               
                                                  setFieldValue(values.fromDate = date)
                                                  

                                                  setFieldValue(values.fromDate1 = moment(date).format("YYYY-MM-DD"))

                                                  // setFieldValue(values.dateOfBirth = date)
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.fromDate &&
                                                    touched.fromDate
                                                    ? " is-invalid"
                                                    : "")
                                                }

                                              /> */}


                                              
<div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                              <Field
                                                as="select"
                                                name="day"
                                                id="day"
                                                // onChange={handleChange}
                                              //  disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                   
                                                    
                                                    var listOfMonth = []
                                                    setFieldValue(values.day = e.target.value)
                                                    if (e.target.value == 31) {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                              
                                                      { "key": 3, "value": "Mar" },
                                              
                                                      { "key": 5, "value": "May" },
                                              
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                              
                                                      { "key": 10, "value": "Oct" },
                                              
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                              
                                              
                                                    } else if (e.target.value == 30) {
                                                      listOfMonth = [
                                              
                                                        { "key": 1, "value": "Jan" },
                                              
                                                        { "key": 3, "value": "Mar" },
                                                        { "key": 4, "value": "Apr" },
                                                        { "key": 5, "value": "May" },
                                                        { "key": 6, "value": "Jun" },
                                                        { "key": 7, "value": "Jul" },
                                                        { "key": 8, "value": "Aug" },
                                                        { "key": 9, "value": "Sep" },
                                                        { "key": 10, "value": "Oct" },
                                                        { "key": 11, "value": "Nov" },
                                                        { "key": 12, "value": "Dec" },
                                              
                                                      ];
                                              
                                              
                                                    }
                                                    else if (e.target.value == 28 || e.target.value == 29) {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                                      { "key": 2, "value": "Feb" },
                                                      { "key": 3, "value": "Mar" },
                                                      { "key": 4, "value": "Apr" },
                                                      { "key": 5, "value": "May" },
                                                      { "key": 6, "value": "Jun" },
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                                      { "key": 9, "value": "Sep" },
                                                      { "key": 10, "value": "Oct" },
                                                      { "key": 11, "value": "Nov" },
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                                    } else {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                                      { "key": 2, "value": "Feb" },
                                                      { "key": 3, "value": "Mar" },
                                                      { "key": 4, "value": "Apr" },
                                                      { "key": 5, "value": "May" },
                                                      { "key": 6, "value": "Jun" },
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                                      { "key": 9, "value": "Sep" },
                                                      { "key": 10, "value": "Oct" },
                                                      { "key": 11, "value": "Nov" },
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                              
                                                    }
                                              setFieldValue(values.listOfMonth= listOfMonth)
                                                    // this.setState({
                                                    //   listOfMonth: listOfMonth
                                                    // })
                                                  }}
                                                className={
                                                  "form-control" +
                                                  (errors.day && touched.day
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">DD</option>
                                                {(
                                                  values.listOfDay ||
                                                  []
                                                ).map(d => (
                                                  <option
                                                    value={d}
                                                  >
                                                    {d}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                              <Field
                                                as="select"
                                                name="month"
                                                id="month"
                                                //   onChange={handleChange}
                                           //     disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                    

                                                    setFieldValue(values.month = e.target.value)
                                                    if (e.target.value == 2) {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 29; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                       // this.setState({ listOfDay: listOfDay });
                                                      }
                                                    } else if (e.target.value == 1 || e.target.value == 3 || e.target.value == 5 || e.target.value == 7 || e.target.value == 8 || e.target.value == 10 || e.target.value == 12) {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 31; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                      //  this.setState({ listOfDay: listOfDay });
                                                      }
                                                    }
                                                    else {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 30; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                      //  this.setState({ listOfDay: listOfDay });
                                                      }
                                                    }

                                                    setFieldValue(values.listOfDay=listOfDay)
                                                  }
                                                }
                                                className={
                                                  "form-control" +
                                                  (errors.month && touched.month
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">MM</option>
                                                {(
                                                 values.listOfMonth ||
                                                  []
                                                ).map(m => (
                                                  <option
                                                    value={m.key}
                                                  >
                                                    {m.value}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                                as="select"
                                                name="year"
                                                id="year"
                                               // onChange={handleChange}
                                            //    disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                    

                                                    setFieldValue(values.year = e.target.value)
                                                  }}
                                                className={
                                                  "form-control" +
                                                  (errors.year && touched.year
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.listOfYear1 ||
                                                  []
                                                ).map(year => (
                                                  <option
                                                    value={year}
                                                  >
                                                    {year}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>

                                              <p className="validation">  {values.errmsg}</p>

                                              {errors.fromDate && <div className="validation">{errors.fromDate}</div>}
                                      </div>
                                      <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                        Registered To Date
                                      </label>
                                      {/* <DatePicker selected={values.toDate}
                                        autoComplete="off"
                                        placeholderText="dd-mm-yyyy"
                                        dateFormat="dd-MM-yyyy"
                                        value={values.toDate}
                                        onChangeRaw={event => {
                                         
                                         let temp = event.target.value
                                         
                                         if (temp !== undefined) {
                                           if (temp.includes("/")) {
                                             
                                             setFieldValue(values.toDate = "")
                                             setFieldValue(values.errmsg1="Date should be in dd-mm-yyyy format.")

                                           }
                                           else {
                                            // setFieldValue(values.toDate = date)
                                             setFieldValue(values.errmsg1="")

                                           }
                                         }
                                       }
                                       }
                                        maxLength="50"
                                                minDate={values.fromDate}
                                                onChange={date => {
                                               
                                                  setFieldValue(values.toDate = date)
                                                  

                                                  setFieldValue(values.toDate1 = moment(date).format("YYYY-MM-DD"))

                                                  // setFieldValue(values.dateOfBirth = date)
                                                }}
                                                className={
                                                  "form-control" +
                                                  (errors.toDate &&
                                                    touched.toDate
                                                    ? " is-invalid"
                                                    : "")
                                                }

                                              /> */}


                                              

<div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                            <div className="col-md-3 col-lg-3 col-sm-3 col-xs-3 pl pr">
                                              <Field
                                                as="select"
                                                name="today"
                                                id="today"
                                                // onChange={handleChange}
                                              //  disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                   
                                                    
                                                    var listOfMonth = []
                                                    setFieldValue(values.today = e.target.value)
                                                    if (e.target.value == 31) {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                              
                                                      { "key": 3, "value": "Mar" },
                                              
                                                      { "key": 5, "value": "May" },
                                              
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                              
                                                      { "key": 10, "value": "Oct" },
                                              
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                              
                                              
                                                    } else if (e.target.value == 30) {
                                                      listOfMonth = [
                                              
                                                        { "key": 1, "value": "Jan" },
                                              
                                                        { "key": 3, "value": "Mar" },
                                                        { "key": 4, "value": "Apr" },
                                                        { "key": 5, "value": "May" },
                                                        { "key": 6, "value": "Jun" },
                                                        { "key": 7, "value": "Jul" },
                                                        { "key": 8, "value": "Aug" },
                                                        { "key": 9, "value": "Sep" },
                                                        { "key": 10, "value": "Oct" },
                                                        { "key": 11, "value": "Nov" },
                                                        { "key": 12, "value": "Dec" },
                                              
                                                      ];
                                              
                                              
                                                    }
                                                    else if (e.target.value == 28 || e.target.value == 29) {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                                      { "key": 2, "value": "Feb" },
                                                      { "key": 3, "value": "Mar" },
                                                      { "key": 4, "value": "Apr" },
                                                      { "key": 5, "value": "May" },
                                                      { "key": 6, "value": "Jun" },
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                                      { "key": 9, "value": "Sep" },
                                                      { "key": 10, "value": "Oct" },
                                                      { "key": 11, "value": "Nov" },
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                                    } else {
                                                      listOfMonth = [{ "key": 1, "value": "Jan" },
                                                      { "key": 2, "value": "Feb" },
                                                      { "key": 3, "value": "Mar" },
                                                      { "key": 4, "value": "Apr" },
                                                      { "key": 5, "value": "May" },
                                                      { "key": 6, "value": "Jun" },
                                                      { "key": 7, "value": "Jul" },
                                                      { "key": 8, "value": "Aug" },
                                                      { "key": 9, "value": "Sep" },
                                                      { "key": 10, "value": "Oct" },
                                                      { "key": 11, "value": "Nov" },
                                                      { "key": 12, "value": "Dec" },
                                                      ];
                                              
                                                    }
                                              setFieldValue(values.listOfMonth1= listOfMonth)
                                                    // this.setState({
                                                    //   listOfMonth: listOfMonth
                                                    // })
                                                  }}
                                          
                                                className={
                                                  "form-control" +
                                                  (errors.today && touched.today
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">DD</option>
                                                {(
                                                  values.listOfDay1 ||
                                                  []
                                                ).map(d => (
                                                  <option
                                                    value={d}
                                                  >
                                                    {d}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                              <Field
                                                as="select"
                                                name="tomonth"
                                                id="tomonth"
                                                //   onChange={handleChange}
                                           //     disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                    

                                                    setFieldValue(values.tomonth = e.target.value)
                                                    if (e.target.value == 2) {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 29; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                       // this.setState({ listOfDay: listOfDay });
                                                      }
                                                    } else if (e.target.value == 1 || e.target.value == 3 || e.target.value == 5 || e.target.value == 7 || e.target.value == 8 || e.target.value == 10 || e.target.value == 12) {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 31; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                      //  this.setState({ listOfDay: listOfDay });
                                                      }
                                                    }
                                                    else {
                                                      var listOfDay = [];
                                                      for (var i = 1; i <= 30; i++) {
                                                        //    var current = year - i;
                                                        listOfDay.push(i);
                                                      //  this.setState({ listOfDay: listOfDay });
                                                      }
                                                    }
                                                    setFieldValue(values.listOfDay1=listOfDay)
                                                  }
                                                }
                                                className={
                                                  "form-control" +
                                                  (errors.tomonth && touched.tomonth
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">MM</option>
                                                {(
                                                  values.listOfMonth1 ||
                                                  []
                                                ).map(m => (
                                                  <option
                                                    value={m.key}
                                                  >
                                                    {m.value}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                            <div className="col-md-5 col-lg-5 col-sm-5 col-xs-5 pl pr">
                                              <Field
                                                as="select"
                                                name="toyear"
                                                id="toyear"
                                               // onChange={handleChange}
                                            //    disabled={this.state.isDisabled}
                                                //  disabled
                                                onChange={
                                                  e => {
                                                    

                                                    setFieldValue(values.toyear = e.target.value)
                                                  }}
                                                className={
                                                  "form-control" +
                                                  (errors.toyear && touched.toyear
                                                    ? "is-invalid"
                                                    : "")
                                                }
                                                className="form-control"
                                              >
                                                <option value="">YYYY</option>
                                                {(
                                                  this.state.listOfYear1 ||
                                                  []
                                                ).map(year => (
                                                  <option
                                                    value={year}
                                                  >
                                                    {year}
                                                  </option>
                                                ))}
                                              </Field>
                                            </div>
                                          </div>

                                              <p className="validation">  {values.errmsg1}</p>

                                              {errors.toDate && <div className="validation">{errors.toDate}</div>}
  </div>
                                      <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                        Completed Stages
                        </label>
                        <Field
                                               as="select"
                                              name="stage"
                                              id="stage"
                                              autoComplete="Quartlet"
                                              // onChange={e=>{
                                              //   setFieldValue(values.stage=e.target.value)
                                              //   localStorage.setItem('stage',e.target.value)
                                                
                                              // }}
                                              className={
                                                "form-control" +
                                                (errors.Quartlet &&
                                                  touched.Quartlet
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder="Quartlet"
                                            >
                                           <option value="">--Select--</option>
                                           
                                          
                                          <option value="REGISTERED">REGISTERED</option>
                                          <option value="PROFILE COMPLETED">PROFILE COMPLETED</option>
                                          <option value="FEAT COMPLETED">FEAT COMPLETED</option>
                                          <option value="NISM VA SUBSCRIBED">NISM VA SUBSCRIBED</option>
                                         

                                          <option value="NISM VA PAYMENT COMPLETED">NISM VA PAYMENT COMPLETED</option>
                                          <option value="NISM PROFILES CREATED">NISM PROFILES CREATED</option>
                                          <option value="NISM EXAM DATE CONFIRMED">NISM EXAM DATE CONFIRMED</option>
                                          <option value="ADMIT CARD AVAILABLE">ADMIT CARD AVAILABLE</option>
                                          <option value="NISM VA CERTIFICATION">NISM VA CERTIFICATION</option>
                                          <option value="KYD-ARN APPLIED">KYD-ARN APPLIED</option>
                                         
                                          <option value="KYD-ARN ACCEPTED">KYD-ARN ACCEPTED</option>
                                          <option value="UNDER EMPANELMENT">UNDER EMPANELMENT</option>
                                          <option value="EMPANELLED">EMPANELLED</option>
                            
                                                </Field>
                                        <ErrorMessage
                                          name="stage"
                                          component="div"
                                          className="validation"
                                        />
                                      </div>
                                      <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12"></div>
                                      <div class="col-md-4 col-sm-6 col-xs-12">
                                        <label>
                                        AMC List
                        </label>
                   



                        <Field
                                               as="select"
                                              name="amcList"
                                              id="amcList"
                                              autoComplete="amcList"
                                              className={
                                                "form-control" +
                                                (errors.amcList &&
                                                  touched.amcList
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              placeholder="amcList"
                                              disabled={values.stage=="UNDER EMPANELMENT" ||values.stage=="EMPANELLED"?false:true}
                                            >

{/* AmcList */}
                                            <option value="">--Select--</option>
                                            {this.state.AmcList&&this.state.AmcList?.length>0 && this.state.AmcList.map(team =>
                                           
                                              <option
                                                key={team.mst_amc_id}
                                                value={team.mst_amc_id}
                                              >
                                                {team.mst_amc_name}
                                              </option>
                                            ) }





                                                </Field>



                                
                                      </div>
                                      

                                     
                                    </div>
                                  </div>
                                  <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-20">
                                    <button
                                      type="submit"
                                      class="btn-4 pull-right"
                                      onClick={async () => {



                                        setFieldValue(
                                          (values.status = 'SEARCH')
                                        );
                                      }}
                                    >Search</button>
                                    <button
                                      type="submit"
                                      id="close"
                                      class="btn-4 mr-20 pull-right"
                                      onClick={async () => {
                                        setFieldValue(
                                          (values.status = 'RESET')
                                        );

                                        setFieldValue(
                                          (values.fname = '')
                                        );
                                        setFieldValue(
                                          (values.lname = '')
                                        );
                                        setFieldValue(
                                          (values.fromDate = '')
                                        ); setFieldValue(
                                          (values.toDate = '')
                                        );
                                        setFieldValue(
                                          (values.emailId = '')
                                        ); setFieldValue(
                                          (values.panNo = '')
                                        );

                                        setFieldValue(
                                          (values.city = '')
                                        );
                                        setFieldValue(
                                          (values.stage = '')
                                        );
                                        setFieldValue(
                                          (values.amcList = '')
                                        );
                                        setFieldValue(
                                          (values.day = '')
                                        );
                                        setFieldValue(
                                          (values.month = '')
                                        );
                                        setFieldValue(
                                          (values.year = '')
                                        );
                                      
                                      
                                        setFieldValue(
                                          (values.today = '')
                                        );
                                        setFieldValue(
                                          (values.tomonth = '')
                                        );
                                        setFieldValue(
                                          (values.toyear = '')
                                        );
                                        localStorage.setItem('stage',"")
                                      }}
                                    >
                                      Reset
                  </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </Form>
                    </React.Fragment>
                  )}
              />)
               }
            
               {
               
               localStorage.getItem("roleId")!=="6"? 
              //  roledata.map((item, key) => (
              //   item.description === 'CIEL Dashboard' ? item.objectActionId.applicationObjectActionName === 'My CIEL OPS' ?
              //   item.objectActionId.applicationObjectId.applicationObjectName==='CIEL Table' ? 
            
                   (
                <div class="row">
                <div class="col-md-4 col-sm-4 col-xs-12 col-md-offset-8 pull-right"></div>
                <div class="col-md-12 col-sm-12 col-xs-12">
                  <div class="table-header">
                    <h3>
                      <div class="row">
                        <div class="col-md-6 col-sm-6 col-xs-12">
                          <span class="left-icon">
                            <i class="fa fa-list" aria-hidden="true"></i>
                          </span>{" "}
                          Distributor List
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                        <span class="right-icon" id="action-dropdown">
                                <a class="mar-left">
                                   
                                   <i
                                     title="Download Profile"
                                     className="fa fa-download"
                                     aria-hidden="true"

                                     onClick={()=> this.exportPDFUserProfile()} 
                                   >
                                   </i>
                                 
                               </a>
                                </span>
                          <span class="right-icon" id="action-dropdown">
                            <a title="Export to Excel">
                              <i
                                onClick={() => this.exportToAMCCSV()}
                                class="fa fa-file-excel-o"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </span>
                          <span class="right-icon" id="action-dropdown">
                            <a title="Export to PDF">
                              <i
                                onClick={() => this.exportAMCPDF()}
                                class="fa fa-file-pdf-o"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </span>
                          {/* <span class="right-icon" id="action-dropdown">
                          <li className="nav-item dropdown notification" id="user-option">
                        <a
                          //onClick={this.signout}
                          className="nav-link text-light"
                          className="notification"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          // title="My Profile"
                        >
                          <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                        </a>
                        <ul className="dropdown-menu" id="notification-profile" style={{ width: 'auto !important' }}>
                          <li className="notification-box">
                            <div class="row">
                              <div class="panel-body">
                                <div className="notification-content">
                                  <div class="col-lg-12 col-sm-12 col-12">

                                      <a  className="text-light " 
                                        >
                                       NISM Profiles Created</a> 

                                    <a className="text-light ">
                                    NISM Status</a>

                                    <a className="text-light">
                                    KYD Applied / ARN Applied</a>

                                    <a className="text-light popup11">
                                    ARN Status</a>
                                    <a className="text-light popup11">
                                    ARN Status</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                          </span> */}
                        </div>
                      </div>
                    </h3>
                  </div>
                  <div class="bg-box">
                    <div class="table-responsive">
                      {/* {localStorage.getItem("roleId")==7? */}
                      {/* {this.props.adminUser[0]["userRoleMatrixList"] !== u   ndefined ?  */}
                     
                      <ReactTable
                        minRows={2}
                        data={this.props.distributorProfileUser===null?[]:this.props.distributorProfileUser}
                        className="-striped -highlight"
                        filterable={false}
                        onPageChange={this.stateonpagechange}
                        defaultFilterMethod={this.filterCaseInsensitive}
                        ref={(refReactTable) => { this.refReactTable = refReactTable; }}

                        columns={[
                          {
                            columns: [
                              {

                                id: "checkbox",
                                accessor: "",
                                Cell: ({ original }) => {

                                    return (
                                        <input
                                            type="checkbox"
                                            className="checkbox"
                                            checked={this.state.selected[original.learnerPartyID] === true}
                                            onChange={() => this.toggleRow(original)}

                                            // disabled={
                                            //     original.executionTracker?.length > 0 ? original.executionTracker[0].additionalDetails.hasOwnProperty('action') === false ? false : true : false
                                            // }
                                        />
                                    );
                                },
                                Header: x => {
                                    return (
                                        <input
                                            type="checkbox"
                                            className="checkbox"
                                            checked={this.state.selectAll === 1}
                                            ref={input => {
                                                if (input) {
                                                    input.indeterminate = this.state.selectAll === 2;
                                                }
                                            }}
                                            onChange={() => this.toggleSelectAll()}
                                            //disabled={true}
                                        // style={{
                                        //     padding:"12px",
                                        //     paddingTop:"2px"
                                        // }

                                        // }
                                        />
                                    );
                                },
                                sortable: false,

                                filterable: false,
                                width: 45,

                            },
                              {
                                Header: "Sr No",
                                id: "row",
                                width: 50,
                                Cell: (row) => {
                                  return <div>{row.index+1}</div>;
                                }
                              },
                             
                              {
                                Header: "Registration Date",
                                id: "Date",
                                accessor: d => moment(d.createdDate.split(" ")[0],"DD/MM/YYYY").format("DD-MM-YYYY") 
                                
                              },
                             
                              {
                                Header: "Completed Stage",
                                id: "Stage",
                                    accessor:
                                 //  d =>d.learnerWorkflowMap[0]?localStorage.getItem('stage')==="UNDER EMPANELMENT"?"UNDER EMPANELMENT":d.learnerWorkflowMap[0].status.toUpperCase():''

                                d =>localStorage.getItem('stage')==="UNDER EMPANELMENT"?
                                "UNDER EMPANELMENT":d.learnerWorkflowMap[0].status.toUpperCase()
                                
                                //d.learnerWorkflowMap[0]? d.learnerWorkflowMap[0].status.toUpperCase():""
                              },
                              {
                                Header: "First Name",
                                id: "fullName",
                                accessor: d => d.firstName,
                                     Cell: props => {
                                  return (
                                    <div>
                                      <a
                                        icons={false}
                                        defaultChecked={
                                          parseInt(props.original.isActive) == 1
                                            ? true
                                            : false
                                        }
                                        onClick={e =>
                                          this.redirectToUserProfile(e, props.original)
                                        }
                                      >{props.original.firstName}</a>
                                    </div>
                                  );
                                }
                              },

                              {
                                Header: "Last Name",
                                id: "LastName",
                                accessor: d =>
                                  d.lastName,
                                  Cell: props => {
                                    return (
                                      <div>
                                        <a
                                          icons={false}
                                          defaultChecked={
                                            parseInt(props.original.isActive) == 1
                                              ? true
                                              : false
                                          }
                                          onClick={e =>
                                            this.redirectToUserProfile(e, props.original)
                                          }
                                        >{props.original.lastName}</a>
                                      </div>
                                    );
                                  }
                              },

                            
                              {
                                Header: "PAN No",
                                id: "panNo",
                                accessor: d => d.panNumber
                              },
                             
                              {
                                Header: "Next Stage",
                                id: "nextStage",
                                accessor: d =>  '',
                                Cell: props => {
                                  if(props.original.learnerWorkflowMap[0])
                                  {
                                 let data=this.state.nextStage.map(a =>
                                     props.original.learnerWorkflowMap[0].status.toUpperCase()==a.currentState?a.nextState.toUpperCase():''
                                    )
                                    return data
                                    }
                                    else{
                                      return ''
                                    }
                                  }
                              },
                             
                              {
                                Header: "Profile Status",
                                id: "applicatonStatus",
                                accessor: d => d.applicationStatus
                              },
                              // {
                              //   Header: "Status",
                              //   id: "isActive",
                              //   filterable: false,
                              //   sortable: false,
                              //   Cell: props => {

                              //     return (
                              //       <div>

                              //         <Toggle
                              //           icons={false}
                              //           defaultChecked={
                              //             parseInt(props.original.isActive) == 1
                              //               ? true
                              //               : false
                              //           }
                              //           onChange={e =>
                              //             this.handleStatus(e, props.original)
                              //           }
                              //         />
                              //       </div>
                              //     );
                              //   }
                              // },
                              // {
                              //   Header: "Block/Unblock",
                              //   id: "loginAttempt",
                              //   filterable: false,
                              //   sortable: false,
                              //   //accessor: d => d.loginAttempt,        
                              //   Cell: props => {
                              //     return (
                              //       <Toggle
                              //         icons={false}
                              //         defaultChecked={
                              //           props.original.loginAttempt >= 3
                              //             ? false
                              //             : true
                              //         }
                              //         onChange={e =>
                              //           this.handleBlock(e, props.original)
                              //         }
                              //       />
                              //     );
                              //   }
                              // },
                              {
                                Header: "Action",
                                id: "action",
                                filterable: false,
                                sortable: false,
                                Cell: props => {
                                  return (
                                    <div>
               

                               <a class="mar-left">
                            
                                   <i
                                     title="Send Mail"
                                     // className="fa fa-view fa-2x"
                                     className="fa fa-paper-plane"
                                     aria-hidden="true"


                                     onClick={e => this.paymentLinkOption(props.original)} 
                                   >
                                   </i>
                                 
                               </a>
{/*                                    
                                      <a class="mar-left">
                                   
                                          <i
                                            title="Edit Profile"
                                            className="fa fa-view fa-2x"
                                            aria-hidden="true"
  

                                            onClick={e => this.exportPDFUserProfile(props.original)} 
                                          >View</i>
                                        
                                      </a>
                                  */}
                                    </div>
                                  );
                                }
                              },

                            ]
                          }
                        ]}
                        defaultPageSize={10}
                        style={{
                          width: "100%",
                          maxHeight: "500px"
                        }}
                      />

                      
                    
                    </div>
                  </div>
                </div>
              </div>


                      ):
                      
                      // item.description === 'ARN Dashboard' ? item.objectActionId.applicationObjectActionName === 'My ARN Table' ?
                      // item.objectActionId.applicationObjectId.applicationObjectName==='ARN Table' ?
                      ( <div class="row">
                      <div class="col-md-4 col-sm-4 col-xs-12 col-md-offset-8 pull-right"></div>
                      <div class="col-md-12 col-sm-12 col-xs-12">
                        <div class="table-header">
                          <h3>
                            <div class="row">
                              <div class="col-md-6 col-sm-6 col-xs-12">
                                <span class="left-icon">
                                  <i class="fa fa-list" aria-hidden="true"></i>
                                </span>{" "}
                                Distributor List 
                              </div>
                              <div class="col-md-6 col-sm-6 col-xs-12">
                                {/* <span class="right-icon" id="action-dropdown">
                                  <a title="">
                                    <i
                                     // onClick={() => this.WorkflowUpdate()}
                                      class="fa fa-dot-circle-o"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </span> */}
                                {/* uncomment from here */}
                                {/* <span class="right-icon" id="action-dropdown">
                                <a class="mar-left">
                                   
                                   <i
                                     title="Audit Trail"
                                     class="fa fa-file-excel-o"
                                      aria-hidden="true"
                                     
                                      onClick={()=> this.auditTrail()} 
                                   >
                                   </i>
                                 
                               </a>
                                </span> */}

<span class="right-icon" id="action-dropdown">
                                <a class="mar-left">
                                   
                                   <i
                                     title="Download Profile"
                                     class="fa fa-file-excel-o"
                                      aria-hidden="true"

                                     onClick={()=> this.exportExcelUserProfile()} 
                                   >
                                   </i>
                                 
                               </a>
                                </span>

                               

                               <span class="right-icon" id="action-dropdown">
                                <a class="mar-left">
                                   
                                   <i
                                     title="Download Profile"
                                     className="fa fa-download"
                                     aria-hidden="true"

                                     onClick={()=> this.exportPDFUserProfile()} 
                                   >
                                   </i>
                                 
                               </a>
                                </span>
                                <span class="right-icon" id="action-dropdown">
                                  <a title="Export to Excel">
                                    <i
                                      onClick={() => this.exportToCSV()}
                                      class="fa fa-file-excel-o"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </span>
                                <span class="right-icon" id="action-dropdown">
                                  <a title="Export to PDF">
                                    <i
                                      onClick={() => this.exportPDF()}
                                      class="fa fa-file-pdf-o"
                                      aria-hidden="true"
                                    ></i>
                                  </a>
                                </span>
                               
                                <span class="right-icon" id="action-dropdown">
                          <li className="nav-item dropdown notification" id="user-option">
                        <a
                          //onClick={this.signout}
                          className="nav-link text-light"
                          className="notification"
                          id="navbarDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          // title="My Profile"
                        >
                          <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                        </a>
                        <ul className="dropdown-menu" id="notification-profile" style={{ width: 'auto !important' }}>
                          <li className="notification-box">
                            <div class="row">
                              <div class="panel-body">
                                <div className="notification-content">
                                  <div class="col-lg-12 col-sm-12 col-12">
                                

                                      <a className="text-light" onClick={this.WorkflowUpdate}>
                                       NISM PROFILE CREATED</a> 

                                    <a className="text-light"  onClick={this.KYDWorkflowUpdate} 
                                    >
                                     KYD /ARN ACCEPTED</a>

                                    {/* <a className="text-light"onClick={e=>{
                                      warning("Coming Soon",warningNotification)
                                    }
                                    }>
                                      UNDER EMPANELMENT
                                   </a> */}

                                    <a className="text-light"  onClick={this.EmpanelledWorkflowUpdate}>
                                    EMPANELLED</a>
                                   
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                          </span>
                          <span class="right-icon" id="action-dropdown">
                            {/* <a data-toggle="tooltip" data-placement="bottom" title="Passed if NISM Score >=50
                            &#13; &#10; Failed if NISM Score <50"> */}
                              <a onClick={this.WhyTheFillForm}>
                              <i
                                class="fa fa-info"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </span>

                              </div>
                            </div>
                          </h3>
                        </div>
                        <div class="bg-box">
                          <div class="table-responsive">
                            {/* {localStorage.getItem("roleId")==7? */}
                            {/* {this.props.adminUser[0]["userRoleMatrixList"] !== u   ndefined ?  */}
                           
                           <ReactTable
                              minRows={2}
                              data={this.props.distributorProfileUser===null?[]:this.props.distributorProfileUser}
                          
      
                              className="-striped -highlight"
                              filterable={false}
                              onPageChange={this.stateonpagechange}
                              defaultFilterMethod={this.filterCaseInsensitive}
                              ref={(refReactTable) => { this.refReactTable = refReactTable; }}
      
                              columns={[
                                {
                                  columns: [
                                    // {
                                    //   Header: (
                                    //     <input
                                    //       label='check '
                                    //       type='checkbox'
                                    //       name="selectall"
                                    //       value="selectall"
                                    //       onChange={this.checkAlluserHandler}
                                    //       checked={this.state.selectAlluser === true ? 'checked' : ""}
                                    //     />
                                    //   ),
                                    //   id: 'checkbox5',
                                    //   width: 30,
                                    //   sortable: false,
                                    //   filterable: false,
                                    //   accessor: d => d.userId,
                                    //   Cell: props => {
      
                                    //     let status = <input type="checkbox" name={props.original.userId}
                                    //       value={props.original.userId} defaultChecked={this.state.selectAlluser}
                                    //       onChange={e => this.handleCheck(props.original)} />
      
      
                                    //     return (
                                    //       <div>
      
                                    //         {status}
                                    //       </div>
                                    //     );
      
                                    //   }
                                    // },
                                    // {
                                    //   Header: "Sr No",
                                    //   id: "partyID",
                                    //   accessor: d => d.partyID.toString()
                                    // },
                                   
                                    {

                                      id: "checkbox",
                                      accessor: "",
                                      Cell: ({ original }) => {
      
                                          return (
                                              <input
                                                  type="checkbox"
                                                  className="checkbox"
                                                  checked={this.state.selected[original.learnerPartyID] === true}
                                                  onChange={() => this.toggleRow(original)}
      
                                                  // disabled={
                                                  //     original.executionTracker?.length > 0 ? original.executionTracker[0].additionalDetails.hasOwnProperty('action') === false ? false : true : false
                                                  // }
                                              />
                                          );
                                      },
                                      Header: x => {
                                          return (
                                              <input
                                                  type="checkbox"
                                                  className="checkbox"
                                                  checked={this.state.selectAll === 1}
                                                  ref={input => {
                                                      if (input) {
                                                          input.indeterminate = this.state.selectAll === 2;
                                                      }
                                                  }}
                                                  onChange={() => this.toggleSelectAll()}
                                                  //disabled={true}
                                              // style={{
                                              //     padding:"12px",
                                              //     paddingTop:"2px"
                                              // }
      
                                              // }
                                              />
                                          );
                                      },
                                      sortable: false,
      
                                      filterable: false,
                                      width: 45,
      
                                  },
                                  {
                                    Header: "Sr No",
                                    id: "row",
                                    width: 50,
                                    Cell: (row) => {
                                      return <div>{row.index+1}</div>;
                                    }
                                  },
                                    {
                                      Header: "First Name",
                                      id: "firstName",
                                      accessor: d => d.firstName,
                                           Cell: props => {
                                        return (
                                          <div>
                                            <a
                                              icons={false}
                                              defaultChecked={
                                                parseInt(props.original.isActive) == 1
                                                  ? true
                                                  : false
                                              }
                                              onClick={e =>
                                                this.redirectToUserProfile(e, props.original)
                                              }
                                            >{props.original.firstName}</a>
                                          </div>
                                        );
                                      }
                                    },
      
                                    {
                                      Header: "Last Name",
                                      id: "lastname",
                                      accessor: d =>
                                        d.lastName,
                                        Cell: props => {
                                          return (
                                            <div>
                                              <a
                                                icons={false}
                                                defaultChecked={
                                                  parseInt(props.original.isActive) == 1
                                                    ? true
                                                    : false
                                                }
                                                onClick={e =>
                                                  this.redirectToUserProfile(e, props.original)
                                                }
                                              >{props.original.lastName}</a>
                                            </div>
                                          );
                                        }
                                    },
      
                                    {
                                      Header: "Email Id",
                                      id: "emailId",
                                      accessor: d => d.emailID
                                    },
      
                                    {
                                      Header: "Mobile No",
                                      id: "mobileNo",
                                      accessor: d => d.mobileNo
                                    },
      
                                    {
                                      Header: "PAN No",
                                      id: "panNo",
                                      accessor: d => d.panNumber
                                    },
                                   
                                    {
                                      Header: "Location",
                                      id: "location",
                                     //accessor: d => d.address[0].cityId,
                                      Cell: props => {
                                        // if(props.original?.length>0)
                                        // {
                                        if(this.state.allCityList?.length > 0){
                                          let cityDetails = props.original.address?.length > 0 ? props.original.address[0].cityId : '';
                                          let la = cityDetails !== '' ?  this.getCity(cityDetails) : '';
                                         return this.titleCase(la);                                        
                                      } else {
                                        return('')
                                      }
                                      // }
                                      // else{
                                      //   return('')
                                      // }
                                    }
                                    
                                    },
                                    {
                                      Header: "Registration Date",
                                      id: "regDate",
                                      accessor: d =>moment( d.createdDate,"DD/MM/YYYY hh:mm:ss").format("DD-MM-YYYY")
                                    },
                                    {
                                      Header: "Who You Are",
                                      id: "whoyouare",
                                      accessor: d =>d.learnerType===1011?"Student":d.learnerType===1012?"Entrepreneur":d.learnerType===1013?"Professional":d.learnerType===1014?"Home Maker":d.learnerType===1015?"Retired":'',
                                    },
                                    {
                                      Header: "College Name",
                                      id: "collegeName",
                                      accessor: d => d.collegeName!==undefined? d.collegeName:"-"
                                    },
                                    {
                                      Header: "FINX Internship",
                                      id: "isFinXInternship",
                                      accessor: d => d.isFinXInternship===1?"Yes":d.isFinXInternship===0?"No":"Not Applicable"
                                    },
                                    {
                                      Header: "Candidate Type",
                                      id: "typeOfCandidate",
                                      Cell: props => {
                                        
                                          if(this.state.lookingForList?.length > 0){
                                        for (let i = 0; i < this.state.lookingForList?.length; i++) {
                                          console.log(this.state.lookingForList[i].codeValueId === Number(props.original.lookingFor))
                                          if (this.state.lookingForList[i].codeValueId === Number(props.original.lookingFor)) {
                                            return this.state.lookingForList[i].codeValue
                                            //return this.state.lookingForList[i].codeValue?this.state.lookingForList[i].codeValue:''
                                          } 
                                          // else {
                                          //   return "Becoming a Mutual fund Distributor"
                                          // }
                                        }
                                      } else {
                                        return('')
                                      }
      
                                      }
                                    },
                                    {
                                      Header: "Completed Stage",
                                      id: "Stage",
                                      accessor: d => localStorage.getItem('stage')==="UNDER EMPANELMENT"?
                                      "UNDER EMPANELMENT":d.learnerWorkflowMap[0].status.toUpperCase()
                                      

                                      //d.learnerWorkflowMap[0]?d.learnerWorkflowMap[0].status.toUpperCase():''
                                      //localStorage.getItem('stage')==="UNDER EMPANELMENT"?"UNDER EMPANELMEN":d.learnerWorkflowMap[0].status.toUpperCase():''
                                    },
                                    {
                                      Header: "Profile Status",
                                      id: "applicatonStatus",
                                      accessor: d => d.applicationStatus
                                    },
                                    {
                                      Header: "Is Amfi User",
                                      id: "isAmfiUser",
                                      accessor: d =>d.isAmfiUser===0?"No":'Yes',
                                    },
                                    {
                                      Header: "Download",
                                      id: "download",
                                      width: 200,
                                      accessor: "",
                                      filterable: false,
                                      Cell: this.renderEditableDownload


                                  },
                                    // {
                                    //   Header: "NISM Score",
                                    //   id: "nismScore",
                                    //   accessor: d => "NA"
                                    // },
                                    // {
                                    //   Header: "NISM Progress",
                                    //   id: "nismProgress",
                                    //   accessor: d => "NA"
                                    // },
                                    {
                                      Header: "Action",
                                      id: "action",
                                      filterable: false,
                                      sortable: false,
                                      Cell: props => {
                                        return (
                                          <div>
{/*                                          
<a class="mar-left">
                                   
                                   <i
                                     title="Download Profile"
                                     className="fa fa-eye"
                                     aria-hidden="true"

        onClick={e => this.filterCfxReport(props.original.emailID,187422)} 
                                   >
                                   </i>
                                 
                               </a> */}
                                         {/* <a class="mar-left">
                                   
                                          <i
                                            title="Download Profile"
                                            className="fa fa-download"
                                            aria-hidden="true"

                                            onClick={e => this.exportPDFUserProfile(props.original)} 
                                          >
                                          </i>
                                        
                                      </a> */}

                                      <a class="mar-left">
                                   
                                          <i
                                            title="Send Mail"
                                            // className="fa fa-view fa-2x"
                                            className="fa fa-paper-plane"
                                            aria-hidden="true"
  

                                            onClick={e => this.paymentLinkOption(props.original)} 
                                          >
                                          </i>
                                        
                                      </a>
                                          </div>
                                        );
                                      }
                                    },
      
                                  ]
                                }
                              ]}
                              defaultPageSize={10}
                              style={{
                                width: "100%",
                                maxHeight: "500px"
                              }}
                            />
      
                            
                          
                          </div>
                        </div>
                      </div>
                    </div>)
               //: "" : "" :"":"" :"" ))
              }
            </div>
          </div>
          <Formik

initialValues={{
  data: [{ "nodeName": "Chapter 1 Growth Mindset", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1730 }, { "nodeName": "Chapter 2 Grit and Resilience", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1731 }, { "nodeName": "Chapter 3 Communication Presentation and Networking", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1732 }, { "nodeName": "Chapter 4 Grooming", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1733 }, { "nodeName": "Chapter 5 Time Management", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Scorm 1.2", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1734 }, { "nodeName": "Session 1 - Investor Psychology; An Introduction - QUIZ", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1735 }, { "nodeName": "Session 2 - Investor Psychology Understanding Biases and Avoiding Pitfalls_QUIZ", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1736 }, { "nodeName": "Session 3 for Developing the RIGHT Mindset Consultative Selling_QUIZ", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1737 }, { "nodeName": "Session 4 - Risk, Return and Asset Allocation_ Quiz", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1738 }, { "nodeName": "Session 5 - Personal finance & investment planning", "score": 0.0, "nodeProgress": 0, "nodeFirstAccessDate": null, "nodeType": "Assessment", "nodeStatus": "Not Started", "nodeLastAccessDate": null, "learningId": 435, "nodeId": 1739 }],

}}

onSubmit={(fields) => {

   
    // reattemptSendMail(data, this.props.history, res => {
    //   console.log(res)
    //   // this.props.history.push("/learnerDashboard");
    //   // window.location.reload()
    //   // if (res.status === "success") {
    //   //   success(
    //   //     "Mail send successfully",
    //   //     successNotification
    //   //   );
    //   //   this.props.history.push("/learnerDashboard");
    //   //   window.location.reload()
    //   // }
    //   // else {
    //   //   warning(

    //   //     "",
    //   //     warningNotification
    //   //   );

    //   // }
    // });


}}

render={({ errors, touched, handleSubmit, setFieldValue, values }) => (
    <React.Fragment>


        <div class="modal hide fade" id="myModal">
            <div class="modal-header">
                <a class="close" data-dismiss="modal">×</a>
                <h3>Modal header</h3>
            </div>
            <div class="modal-body">
                <p>One fine body…</p>
            </div>
            <div class="modal-footer">
                <a href="#" class="btn">Close</a>
                <a href="#" class="btn btn-primary">Save changes</a>
            </div>
        </div>
        <div
            className="modal fade"
            id="progressBarPopup"

            tabindex="-1" role="dialog" aria-labelledby="modalLabel"    data-keyboard="true" aria-hidden="true"
        >
           
                <div className="modal-dialog modal-md" role="document">
                <Form onSubmit={handleSubmit} className="form_name">
                    <div className="modal-content">
                        <button
                              type="reset"
                            class="close"
                              aria-label="Close"
                            onClick={
                                e => {
                                    window.$('#progressBarPopup').modal('hide')
                                }
                            }
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>

                        <section className="registration">
                            <div className="modal-body">
                                <div classNames="">
                                    <div className="modal-head" style={{
                                        padding: "9px 8px"
                                    }}>
                                        <div className="" style={{ textAlign: "center" }} >
                                            <img src={ciellogo} className="img-responsive cielLogo" />
                                            <h5 style={{ color: "black" }} >Company Slogan</h5>
                                            <div>

                                            </div>
                                            {/* <h5 style={{ padding: "25px 10px" }} >This certificate is awaited to{" "}
                                                <b style={{ color: "black", fontSize: "20px" }}>{JSON.parse(Pdata).responseObject.firstName} {" "} {JSON.parse(Pdata).responseObject.lastName}
                                                </b> {" "}for successfully completing the NISM training</h5> */}
                                        </div>

                                    </div>
                                    <div className="">
                                      <center>
                                            <h5 style={{ color: "black" }} >NISM VA content node 90%</h5>
                                            <table id="progressstatusPopup">
                                                <tr>
                

                                                </tr>
                                                {this.state.Scoredata?.length>0 && this.state.Scoredata[0].learnernode.map((e, index) => {
                                                   
                                                    return (
                                                        <tr>
                                                            <td>{e.nodeName}</td>
                                                            <td>{e.score}</td>
                                                            <td>{e.nodeStatus}</td>
                                                        </tr>
                                                    )
                                                })}
                                              


                                            </table>

                                        </center> 
                                        {/* <button className="btn-5 mr-10" onClick={this.downloadAsPdf}>Download Scorecard
                                        </button> */}
                                        {/* {flag == true ? <button className="btn-5" onClick={this.downloadAsCertificate}>Download Certificate  </button> : ''} */}

                                        <div style={{ textAlign: "right", paddingTop: "15px" }}>

                                            <img src={CielSignature} className="img-responsive cielSign" />
                                            CIEL Signatory
</div>
                                        < br />

                                    </div>

                                </div>
                            </div>
                        </section>
                    </div>
                    </Form>
                </div>
         
        </div>
    </React.Fragment>
)}
/>





          {/* Open add modules popup   */}
          {/* <div class="modal fade" id="modal-send-mail" tabindex="-1" role="dialog" aria-labelledby="modalLabel"    data-keyboard="true" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
              <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    subject: '',
                    emailId: '',
                    message: ''
                  }}
                  validationSchema={Yup.object().shape({
                    //static validations
                    subject: Yup.string()
                      .required('You must specify a subject'),
                    emailId: Yup.string()
                      .email('Invalid E-Mail'),
                    //.required('You must specify a E-Mail Id'),
                    message: Yup.string()
                      .required('You must specify a Message'),
                  }
                  )}

                  // onSubmit={(values, actions) => {
                  //   //console.log("Submitted :" + JSON.stringify(values));
                  // }}
                  onSubmit={(fields, { resetForm }) => {
                    //console.log("field", fields.subject)
                    
                    var adminPartyid = localStorage.getItem("userid-Token");
                    //console.log("adminPartyid", adminPartyid)
                    let data = {
                      fullName: this.state.dat,
                      emailID: this.state.dat2,
                      enquirySubject: fields.subject,
                      ccemailList: fields.emailId,
                      enquiryMessage: fields.message,
                      learnerPartyID: this.state.stud,
                      adminPartyID: adminPartyid,
                      enquiryType: 2
                    }

                    //console.log("dataemail", data)
                    GeneralEnquiryService.PostEnquiry(data, res => {
                      //console.log("res", res)
                      if (res.status === "success") {
                        success(
                          "Message has been delivered to the user successfully.",
                          successNotification
                        );
                        $(document).ready(function () {
                          $("#close").click();
                        });
                        resetForm({});
                      }
                    });
                  }}

                  render={({
                    errors, touched, handleSubmit
                  }) => (
                      <React.Fragment>
                        <Form onSubmit={handleSubmit} className="form-group">
                          <section class="updateGDPI">
                            <div class="modal-body">
                              <div class="row">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                  <div class="product-add">
                                    <div class="form-group">
                                      <div class="row">
                                        <div class="col-md-12 col-sm-12 col-xs-12">
                                          <label>
                                            Subject
                                          <span className="validation"> *</span>
                                          </label>
                                          <Field
                                            type="text"
                                            name="subject"
                                            id="subject"
                                            autoComplete="subject"
                                            className={
                                              "form-control" +
                                              (errors.subject &&
                                                touched.text
                                                ? " is-invalid"
                                                : "")
                                            }
                                            placeholder="Subject"
                                            className="form-control"
                                          />
                                          <ErrorMessage
                                            name="subject"
                                            component="div"
                                            className="validation"
                                          />
                                        </div>
                                        <div class="col-md-12 col-sm-12 col-xs-12">
                                          <label>
                                            CC
                                          </label>
                                          <Field
                                            type="emailId"
                                            name="emailId"
                                            id="emailId"
                                            autoComplete="emailId"
                                            className={
                                              "form-control" +
                                              (errors.emailId &&
                                                touched.emailId
                                                ? " is-invalid"
                                                : "")
                                            }
                                            placeholder="CC"
                                          />
                                          <ErrorMessage
                                            name="emailId"
                                            component="div"
                                            className="validation"
                                          />
                                        </div>
                                        <div class="col-md-12 col-sm-12 col-xs-12">
                                          <label>
                                            Message
                                          <span className="validation"> *</span>
                                          </label>
                                          <Field as="textarea" rows="8" cols="50" name="message"
                                            id="message"
                                            autoComplete="message"
                                            className={
                                              "form-control" +
                                              (errors.message && touched.message
                                                ? " is-invalid"
                                                : "")
                                            }
                                          />
                                          <ErrorMessage
                                            name="message"
                                            className="validation"
                                            component="div"
                                          />
                                       
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-20">
                                      <button
                                        type="submit"
                                        class="btn-4 pull-right"
                                      >Send</button>
                                      <button
                                        type="button"
                                        id="close"
                                        class="btn-4 mr-20 pull-right"
                                        data-dismiss="modal" aria-label="Close"
                                      >
                                        Cancel
                                    </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </Form>
                      </React.Fragment>
                    )}
                />
              </div>
              </div>
            </div> */}
            </div>
          </div>
        </section>

        <Modal
          open={this.state.showWhyTheFillForm}
          onClose={this.onWhyTheFillFormCloseModal}
          center
        >
          <div
            className=""
            id="roadmap"
            tabindex="-1" role="dialog" aria-labelledby="modalLabel"    data-keyboard="true" aria-hidden="true"
          >
            <div className="modal-dialog modal-md" role="document">
              <div class="modal-content">
                <div className="modal-header">
                  <div class="scr-board">
                    <h2>Result Category</h2>
                    <div class="bottom-line"></div>
                  </div>
                  {/* <h4 className="modal-title">FinX Core Login</h4> */}
                </div>
                <div className="modal-body">
                  {/* The Profile Form is a means of gathering your information which would help us in serving you more efficiently through your journey towards becoming a Mutual Fund Advisor. */}
                  {/* <img src={ScoreRange} className="img-responsive" /> */}
                  <div id="scoreRange">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <th>Score</th>
                        <th>Result </th>
                      </tr>
                      <tr>
                      <td>&#62;=50</td>
                        <td>Pass</td>
                      </tr>
                      <tr>
                      <td>&#60;50</td>
                        <td>Fail</td>
                      </tr>
                     
                    </table>
                  </div>
                </div>
                <div class="modal-footer">
                  {/* <button
                      type="button"
                      className="btn-5 mt-40 mr-20"
                      name="btnYes"
                    onClick={this.getPaymentLink}
                    >
                      Yes
                    </button> */}
                  <button
                    type="button"
                    className="btn-5"
                    name="btnNo"
                    onClick={this.onWhyTheFillFormCloseModal}
                  >
                    Ok
                    </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
     
      </React.Fragment>
    );
  }
}

export default DistributorList;